angular.module('controllers').controller('restaurantController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window', 'Mqtt',
        function($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $route, $routeParams, $location, $timeout, $interval, $window, Mqtt) {

                Mqtt.connect($rootScope.mq);

                $rootScope.path = '/restaurant';
                $scope.path = $rootScope.path;
                $rootScope.modelName = 'restaurant';
                $scope.pathTemplate = 'restaurants/restaurants';
                $scope.title = 'Restaurante';

                angular.extend(this, $controller('crudController', { $scope: $scope }));

                $scope.sortType = 'restaurant_title';
                $scope.defaultItem = 10;
                $rootScope.typeId = 'id';
                $scope.search.order = 'asc';
                $scope.classAction = 'td-big';
                $scope.columns = {
                        'restaurant_title': { 'label': 'Restaurant', 'filter': 1, 'filterType': 'input' },
                        'restaurant_no_tables': { 'label': 'Nr. mese', 'filter': 1, 'filterType': 'input' },
                        'status': { 'label': 'Status', 'filter': 1, 'filterType': 'select' }
                };

                $scope.columns.status.options = [
                        { 'id': '', 'value': '' },
                        { 'id': 1, 'value': 'true' },
                        { 'id': 0, 'value': 'false' }
                ];

                $scope.additionals['content_type'] = 'form-urlencoded';
                $scope.additionals['columnDisplay'] = 'restaurant_title';

                $scope.maxDate = new Date();
                $scope.minDate = '2010-01-01';
                var current_init_date = new Date();
                current_init_date.setHours(0, 0, 0, 0);
                $scope.search.dateFrom = current_init_date;

                $scope.additionals['functionResult'] = function(ev, data) {
                        if (!angular.isUndefined($scope.modelData.restaurant_title)) {
                                $scope.modelData.restaurant_title = $scope.additionals['formatTextResult']($scope.modelData.restaurant_title);
                        }
                        if (!angular.isUndefined($scope.modelsData)) {
                                angular.forEach($scope.modelsData, function(item, key) {
                                        if (!angular.isUndefined($scope.modelsData[key].restaurant_title)) {
                                                $scope.modelsData[key].restaurant_title = $scope.additionals['formatTextResult']($scope.modelsData[key].restaurant_title);
                                        }
                                });
                        }
                }

                /*add waiters*/
                function createFilterForWaiter(query) {
                        var lowercaseQuery = angular.lowercase(query);
                        return function filterFn(item) {
                                return item.username.indexOf(lowercaseQuery) >= 0;
                        };
                }

                $scope.additionals['waitersResults'] = [];
                $scope.additionals['getWaiters'] = function(model) {
                        Crud.get($scope.path + '/getWaiters')
                                .success(function(data) {
                                        $scope.additionals['waitersResults'] = data.waiters;

                                        /*autocomplete*/
                                        function querySearch(query) {
                                                var results = query ? $scope.additionals['waitersResults'].filter(createFilterForWaiter(query)) : [];
                                                return results;
                                        }
                                        $scope.additionals['searchWaiter'] = querySearch;
                                        $scope.additionals['errors'] = {};
                                        /*end autocomplete*/
                                });
                }

                $scope.additionals['selectedItemWaiter'] = [];

                /* add multiple waiter forms */
                $scope.additionals['waiters'] = [{}];
                $scope.additionals['cloneItem'] = function(model, modelLength) {
                        var itemToClone = {};
                        $scope.additionals[model].push(itemToClone);
                        angular.forEach($scope.modelData[model], function(item, key) {
                                $scope.additionals['selectedItemWaiter'][$scope.additionals[model].length - 1] = '';
                        });
                }
                $scope.additionals['removeItem'] = function(itemIndex, modelWaiter) {
                        if (!angular.isUndefined($scope.errors)) {
                                if (!angular.isUndefined($scope.errors['waiters.' + itemIndex + '.username'])) {
                                        delete $scope.errors['waiters.' + itemIndex + '.username'];
                                }
                                if (!angular.isUndefined($scope.errors['waiters.' + itemIndex + '.user_id'])) {
                                        delete $scope.errors['waiters.' + itemIndex + '.user_id'];
                                }
                        }

                        $scope.interm = [];
                        angular.forEach($scope.additionals[modelWaiter], function(itemy, indexy) {
                                $scope.interm[indexy] = {
                                        'user_id': itemy['user_id'],
                                        'username': itemy['username']
                                };
                        });
                        $scope.interms = [];
                        angular.forEach($scope.interm, function(itemyy, indexyy) {
                                $scope.interms.push({
                                        'user_id': itemyy['user_id'],
                                        'username': itemyy['username']
                                });
                        });
                        $scope.interms.splice(itemIndex, 1);
                        $scope.additionals[modelWaiter] = $scope.interms;

                        $timeout(function() {
                                $scope.modelData.waiters = $scope.additionals[modelWaiter];
                        }, 100);

                }

                /* close field */
                $scope.additionals['closeField'] = function(paramName, model, keyWaiter, key) {
                        if (!angular.isUndefined(key)) {
                                model[key][paramName] = '';
                        } else {
                                model.waiters[keyWaiter][paramName] = '';
                        }
                }

                /* change field */
                $scope.additionals['changeField'] = function(model, prop, indexWaiter) {
                        if (prop == 'waiter') {
                                if (!angular.isUndefined(model.waiters[indexWaiter])) {
                                        model.waiters[indexWaiter].waiter_new = false;
                                }
                        }
                }

                $scope.addWaitersModel = function(ev, path, model) {
                        $scope.additionals['getWaiters']();

                        if ($scope.mode_action == 'page') {
                                $scope.controlSH = true;
                                $scope.action = 'waiter';
                                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                                $scope.additionals['invalid'] = '';

                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        switch (key) {
                                                case 'waiters':
                                                        currentModel['waiters'] = [];
                                                        angular.forEach(item, function(itemWaiters, keyWaiters) {
                                                                $scope.additionals['selectedItemWaiter'][keyWaiters] = '';

                                                                currentModel['waiters'][keyWaiters] = {};
                                                                angular.forEach(itemWaiters, function(itemWaitersDetail, keyWaitersDetail) {
                                                                        currentModel['waiters'][keyWaiters][keyWaitersDetail] = itemWaitersDetail;
                                                                });
                                                        });
                                                        break;
                                                default:
                                                        currentModel[key] = item;
                                                        break;
                                        }
                                });
                                $scope.modelData = currentModel;
                                if (angular.isUndefined(currentModel.waiters) || currentModel.waiters.length == 0) {
                                        currentModel.waiters = [{}];
                                }
                                $scope.additionals['waiters'] = currentModel.waiters;

                                $scope.cancel = function() {
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.controlSH = false;
                                };

                                $scope.addWaiter = function() {

                                        angular.forEach($scope.modelData.waiters, function(item, indexWaiters) {
                                                if (item['username'] != '' && $scope.additionals['waitersResults']) {
                                                        var checkWaiterId = $scope.additionals['checkField']($scope.additionals['waitersResults'], 'id', 'username', item['username']);
                                                        if (checkWaiterId) {
                                                                item.user_id = checkWaiterId;
                                                        } else {
                                                                item.user_id = 0;
                                                        }
                                                        var checkWaiterName = $scope.additionals['checkField']($scope.additionals['waitersResults'], 'username', 'username', item['username']);
                                                        if (checkWaiterName) {
                                                                item.username = checkWaiterName;
                                                        }
                                                }
                                        });
                                        $scope.additionals['buttonDisabled'] = true;
                                        $scope.isLoading = true;
                                        var post = {};
                                        post['route'] = 'waiter';
                                        post['waiters'] = $scope.modelData['waiters'];
                                        post['id'] = model['id'];
                                        Crud.post($scope.additionals['content_type'], post, path + '/waiter')
                                                .success(function(data) {
                                                        if (!angular.isUndefined(data.invalid)) {
                                                                $scope.additionals['invalid'] = data.invalid;
                                                        } else {
                                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                        $scope.additionals['functionResult'](ev, data);
                                                                }
                                                                /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                                 $scope.selected[model[$rootScope.typeId]] = model;
                                                                 }*/
                                                                if (!angular.isUndefined(data.currentModel)) {
                                                                        if (!angular.isUndefined($scope.models)) {
                                                                                $scope.getElement($scope.models, data.currentModel);
                                                                        }
                                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                                $scope.modelData = data.currentModel;
                                                                        }
                                                                } else {
                                                                        if (!angular.isUndefined($scope.models)) {
                                                                                $scope.getElement($scope.models, currentModel);
                                                                        }
                                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                                $scope.modelData = currentModel;
                                                                        }
                                                                }
                                                        }
                                                        $scope.modelData = {};
                                                        $scope.errors = {};
                                                        $scope.isLoading = false;
                                                        $scope.controlSH = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                })
                                                .error(function(data) {
                                                        $scope.isLoading = false;
                                                        $scope.errors = data.errors;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                });
                                };
                        }

                        if ($scope.mode_action == 'dialog') {
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        switch (key) {
                                                case 'waiters':
                                                        currentModel['waiters'] = [];
                                                        angular.forEach(item, function(itemWaiters, keyWaiters) {
                                                                $scope.additionals['selectedItemWaiter'][keyWaiters] = '';
                                                                currentModel['waiters'][keyWaiters] = {};
                                                                angular.forEach(itemWaiters, function(itemWaitersDetail, keyWaitersDetail) {
                                                                        currentModel['waiters'][keyWaiters][keyWaitersDetail] = itemWaitersDetail;
                                                                });
                                                        });
                                                        break;
                                                default:
                                                        currentModel[key] = item;
                                                        break;
                                        }
                                });

                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'waiterDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {
                                                pathTemplate: $scope.pathTemplate,
                                                model: currentModel,
                                                selected: $scope.selected,
                                                additionals: $scope.additionals
                                        }
                                }).then(function() {
                                        if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                                if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                                                        }
                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                                                        }
                                                } else {
                                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                                                        }
                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                $scope.modelData = currentModel;
                                                        }
                                                }

                                        }
                                });
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;
                                        $scope.selected = selected;

                                        $scope.cancel = function() {
                                                $mdDialog.cancel();
                                        };

                                        $scope.additionals['removeItem'] = function(itemIndex, modelWaiter) {
                                                if (!angular.isUndefined($scope.errors)) {
                                                        if (!angular.isUndefined($scope.errors['waiters.' + itemIndex + '.username'])) {
                                                                delete $scope.errors['waiters.' + itemIndex + '.username'];
                                                        }
                                                        if (!angular.isUndefined($scope.errors['waiters.' + itemIndex + '.user_id'])) {
                                                                delete $scope.errors['waiters.' + itemIndex + '.user_id'];
                                                        }
                                                }

                                                $scope.interm = [];
                                                angular.forEach($scope.additionals[modelWaiter], function(itemy, indexy) {
                                                        $scope.interm[indexy] = {
                                                                'user_id': itemy['user_id'],
                                                                'username': itemy['username']
                                                        };
                                                });
                                                $scope.interms = [];
                                                angular.forEach($scope.interm, function(itemyy, indexyy) {
                                                        $scope.interms.push({
                                                                'user_id': itemyy['user_id'],
                                                                'username': itemyy['username']
                                                        });
                                                });
                                                $scope.interms.splice(itemIndex, 1);
                                                $scope.additionals[modelWaiter] = $scope.interms;

                                                $timeout(function() {
                                                        $scope.modelData.waiters = $scope.additionals[modelWaiter];
                                                }, 100);

                                        }

                                        if (angular.isUndefined($scope.modelData.waiters) || $scope.modelData.waiters.length == 0) {
                                                $scope.modelData.waiters = [{}];
                                        }
                                        $scope.additionals['waiters'] = $scope.modelData.waiters;

                                        $scope.addWaiter = function() {

                                                angular.forEach($scope.modelData.waiters, function(item, indexWaiters) {
                                                        if (item['username'] != '' && $scope.additionals['waitersResults']) {
                                                                var checkWaiterId = $scope.additionals['checkField']($scope.additionals['waitersResults'], 'id', 'username', item['username']);
                                                                if (checkWaiterId) {
                                                                        item.user_id = checkWaiterId;
                                                                } else {
                                                                        item.user_id = 0;
                                                                }
                                                                var checkWaiterName = $scope.additionals['checkField']($scope.additionals['waitersResults'], 'username', 'username', item['username']);
                                                                if (checkWaiterName) {
                                                                        item.username = checkWaiterName;
                                                                }
                                                        }
                                                });

                                                $scope.isLoading = true;
                                                $scope.additionals['buttonDisabled'] = true;
                                                var post = {};
                                                post['route'] = 'waiter';
                                                post['waiters'] = $scope.modelData['waiters'];
                                                post['id'] = $scope.modelData['id'];
                                                Crud.post($scope.additionals['content_type'], post, path + '/waiter')
                                                        .success(function(data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                } else {
                                                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                $scope.additionals['functionResult'](ev, data);
                                                                        }
                                                                        /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                                                         $scope.selected[model[$rootScope.typeId]] = model;
                                                                         }*/
                                                                        if (!angular.isUndefined(data.currentModel)) {
                                                                                $scope.additionals['dataCurrentModel'] = data.currentModel;

                                                                        }

                                                                }
                                                                $scope.isLoading = false;
                                                                $mdDialog.hide();
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function(data) {
                                                                $scope.isLoading = false;
                                                                $scope.errors = data.errors;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        });
                                        };
                                }
                        }

                };
                /*end add waiters*/

                /*add tables*/
                $scope.additionals['tables'] = [{}];
                $scope.additionals['cloneItemTable'] = function(model, modelLength) {
                        var itemToClone = {};
                        $scope.additionals[model].push(itemToClone);
                }
                $scope.additionals['removeItemTable'] = function(itemIndex, modelTable) {
                        if (!angular.isUndefined($scope.errors)) {
                                if (!angular.isUndefined($scope.errors['tables.' + itemIndex + '.table_title'])) {
                                        delete $scope.errors['tables.' + itemIndex + '.table_title'];
                                }
                                if (!angular.isUndefined($scope.errors['tables.' + itemIndex + '.table_seats'])) {
                                        delete $scope.errors['tables.' + itemIndex + '.table_seats'];
                                }
                                if (!angular.isUndefined($scope.errors['tables.' + itemIndex + '.id'])) {
                                        delete $scope.errors['tables.' + itemIndex + '.id'];
                                }
                        }

                        $scope.interm = [];
                        angular.forEach($scope.additionals[modelTable], function(itemy, indexy) {
                                $scope.interm[indexy] = {
                                        'id': itemy['id'],
                                        'table_title': itemy['table_title'],
                                        'table_seats': itemy['table_seats']
                                };
                        });
                        $scope.interms = [];
                        angular.forEach($scope.interm, function(itemyy, indexyy) {
                                $scope.interms.push({
                                        'id': itemyy['id'],
                                        'table_title': itemyy['table_title'],
                                        'table_seats': itemyy['table_seats']
                                });
                        });
                        $scope.interms.splice(itemIndex, 1);
                        $scope.additionals[modelTable] = $scope.interms;

                        $timeout(function() {
                                $scope.modelData.tables = $scope.additionals[modelTable];
                        }, 100);

                }

                $scope.saveConfigurationTable = function(ev, path, restaurant_id, restaurant_key) {
                        if ($scope.mode_action == 'dialog') {

                                $scope.additionals['invalid'] = '';
                                $scope.errors = {};
                                $scope.modelData = {};

                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'configurationDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {
                                                pathTemplate: $scope.pathTemplate,
                                                model: $scope.modelData,
                                                additionals: $scope.additionals,
                                                action: $scope.action
                                        }
                                }).then(function() {

                                });
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals', 'action'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, additionals, action) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;
                                        $scope.action = action;

                                        $scope.cancel = function() {
                                                $mdDialog.cancel();
                                        };

                                        if (!angular.isUndefined($scope.additionals['function'])) {
                                                $scope.additionals['function'](ev, $scope.modelData);
                                        }

                                        $scope.saveConfiguration = function() {
                                                $scope.additionals['buttonDisabled'] = true;
                                                if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                                        $scope.additionals['internFunction'](ev, $scope.modelData);
                                                }
                                                $scope.isLoading = true;

                                                var post = {};
                                                post['route'] = 'saveConfiguration';
                                                post['coordinates'] = $rootScope.dropResult;

                                                Crud.post($scope.additionals['content_type'], post, path + '/saveConfiguration')
                                                        .success(function(data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                } else {
                                                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                $scope.additionals['functionResult'](ev, data);
                                                                        }
                                                                        if (!angular.isUndefined(data.currentModel)) {
                                                                                $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                                        }

                                                                }
                                                                $scope.isLoading = false;
                                                                $mdDialog.hide();
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function(data) {
                                                                $scope.isLoading = false;
                                                                $scope.errors = data.errors;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                                if (data == null) {
                                                                        $rootScope.checkNetworkConnection();
                                                                }
                                                        });
                                        };

                                }
                        }
                };


                $scope.addTablesModel = function(ev, path, model) {

                        if ($scope.mode_action == 'page') {
                                $scope.controlSH = true;
                                $scope.action = 'table';
                                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                                $scope.additionals['invalid'] = '';

                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        switch (key) {
                                                case 'tables':
                                                        currentModel['tables'] = [];
                                                        angular.forEach(item, function(itemTables, keyTables) {
                                                                currentModel['tables'][keyTables] = {};
                                                                angular.forEach(itemTables, function(itemTablesDetail, keyTablesDetail) {
                                                                        currentModel['tables'][keyTables][keyTablesDetail] = itemTablesDetail;
                                                                });
                                                        });
                                                        break;
                                                default:
                                                        currentModel[key] = item;
                                                        break;
                                        }
                                });
                                $scope.modelData = currentModel;
                                if (angular.isUndefined(currentModel.tables) || currentModel.tables.length == 0) {
                                        currentModel.tables = [{}];
                                }
                                $scope.additionals['tables'] = currentModel.tables;

                                $scope.cancel = function() {
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.controlSH = false;
                                };

                                $scope.addTable = function() {

                                        $scope.additionals['buttonDisabled'] = true;
                                        $scope.isLoading = true;
                                        var post = {};
                                        post['route'] = 'table';
                                        post['tables'] = $scope.modelData['tables'];
                                        post['id'] = model['id'];
                                        Crud.post($scope.additionals['content_type'], post, path + '/table')
                                                .success(function(data) {
                                                        if (!angular.isUndefined(data.invalid)) {
                                                                $scope.additionals['invalid'] = data.invalid;
                                                        } else {
                                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                        $scope.additionals['functionResult'](ev, data);
                                                                }
                                                                if (!angular.isUndefined(data.currentModel)) {
                                                                        if (!angular.isUndefined($scope.models)) {
                                                                                $scope.getElement($scope.models, data.currentModel);
                                                                        }
                                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                                $scope.modelData = data.currentModel;
                                                                        }
                                                                } else {
                                                                        if (!angular.isUndefined($scope.models)) {
                                                                                $scope.getElement($scope.models, currentModel);
                                                                        }
                                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                                $scope.modelData = currentModel;
                                                                        }
                                                                }
                                                        }
                                                        $scope.modelData = {};
                                                        $scope.errors = {};
                                                        $scope.isLoading = false;
                                                        $scope.controlSH = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                })
                                                .error(function(data) {
                                                        $scope.isLoading = false;
                                                        $scope.errors = data.errors;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                });
                                };
                        }

                        if ($scope.mode_action == 'dialog') {
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        switch (key) {
                                                case 'tables':
                                                        currentModel['tables'] = [];
                                                        angular.forEach(item, function(itemTables, keyTables) {
                                                                currentModel['tables'] = [];
                                                                angular.forEach(item, function(itemTables, keyTables) {
                                                                        currentModel['tables'][keyTables] = {};
                                                                        angular.forEach(itemTables, function(itemTablesDetail, keyTablesDetail) {
                                                                                currentModel['tables'][keyTables][keyTablesDetail] = itemTablesDetail;
                                                                        });
                                                                });
                                                        });
                                                        break;
                                                default:
                                                        currentModel[key] = item;
                                                        break;
                                        }
                                });

                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'tableDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {
                                                pathTemplate: $scope.pathTemplate,
                                                model: currentModel,
                                                selected: $scope.selected,
                                                additionals: $scope.additionals
                                        }
                                }).then(function() {
                                        if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                                                if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                                                        }
                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                                                        }
                                                        if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                                                $scope.getElement($scope.additionals['restaurants'], $scope.additionals['dataCurrentModel']);
                                                        }
                                                } else {
                                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                                                        }
                                                        if (!angular.isUndefined($scope.modelData)) {
                                                                $scope.modelData = currentModel;
                                                        }
                                                }
                                        }
                                });
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;
                                        $scope.selected = selected;

                                        $scope.cancel = function() {
                                                $mdDialog.cancel();
                                        };

                                        $scope.additionals['removeItem'] = function(itemIndex, modelTable) {
                                                if (!angular.isUndefined($scope.errors)) {
                                                        if (!angular.isUndefined($scope.errors['tables.' + itemIndex + '.table_title'])) {
                                                                delete $scope.errors['tables.' + itemIndex + '.table_title'];
                                                        }
                                                        if (!angular.isUndefined($scope.errors['tables.' + itemIndex + '.id'])) {
                                                                delete $scope.errors['tables.' + itemIndex + '.id'];
                                                        }
                                                }

                                                $scope.interm = [];
                                                angular.forEach($scope.additionals[modelTable], function(itemy, indexy) {
                                                        $scope.interm[indexy] = {
                                                                'id': itemy['id'],
                                                                'table_title': itemy['table_title']
                                                        };
                                                });
                                                $scope.interms = [];
                                                angular.forEach($scope.interm, function(itemyy, indexyy) {
                                                        $scope.interms.push({
                                                                'id': itemyy['id'],
                                                                'table_title': itemyy['table_title']
                                                        });
                                                });
                                                $scope.interms.splice(itemIndex, 1);
                                                $scope.additionals[modelTable] = $scope.interms;

                                                $timeout(function() {
                                                        $scope.modelData.tables = $scope.additionals[modelTable];
                                                }, 100);

                                        }

                                        if (angular.isUndefined($scope.modelData.tables) || $scope.modelData.tables.length == 0) {
                                                $scope.modelData.tables = [{}];
                                        }
                                        $scope.additionals['tables'] = $scope.modelData.tables;

                                        $scope.addTable = function() {
                                                $scope.isLoading = true;
                                                $scope.additionals['buttonDisabled'] = true;
                                                var post = {};
                                                post['route'] = 'table';
                                                post['tables'] = $scope.modelData['tables'];
                                                post['id'] = $scope.modelData['id'];
                                                Crud.post($scope.additionals['content_type'], post, path + '/table')
                                                        .success(function(data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                } else {
                                                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                $scope.additionals['functionResult'](ev, data);
                                                                        }
                                                                        if (!angular.isUndefined(data.currentModel)) {
                                                                                $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                                        }
                                                                }
                                                                $scope.isLoading = false;
                                                                $mdDialog.hide();
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function(data) {
                                                                $scope.isLoading = false;
                                                                $scope.errors = data.errors;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        });
                                        };
                                }
                        }

                };
                /*end add tables*/
                
                $scope.additionals['table_status'] = {};
                        $scope.additionals['table_status'].options = [
                                {
                                        'id': 0,
                                        'value': 'Libera',
                                        'background': 'rgba(255, 255, 255, 0.8)', 
                                        'color': 'rgba(193, 32, 38, 1)'
                                },
                                {
                                        'id': 1,
                                        'value': 'Ocupata',
                                        'background': 'rgba(200, 42, 38, 0.9)',
                                        'color': 'rgba(255, 255, 255, 1)'
                                },
                        ];

                        $scope.controlFullscreenRestaurant = 0;
                        function closeFullscreen(e) {
                            if  ($scope.controlFullscreenRestaurant == 0) {
                                         if (document.documentElement.requestFullscreen) {
                                               // document.documentElement.requestFullscreen();
                                          } else if (document.documentElement.mozRequestFullscreen) {
                                                document.documentElement.mozRequestFullscreen();
                                         } else if (document.documentElement.webkitRequestFullscreen) {
                                                document.documentElement.webkitRequestFullscreen();
                                         } else if (document.documentElement.msRequestFullscreen) {
                                                document.documentElement.msRequestFullscreen();
                                         }
                                        $scope.controlFullscreenRestaurant = 1;
                                        $('body').addClass('full-screen');
                                        $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer, .nav').addClass('hide');
                                        $('.toggle-fullscreen-button').css({'background-position' :  ' 4px -24px'});
                                         $('#tabs md-tab-content').css({'min-height' :  'calc(100vh'});
                                   } else {
                                        $scope.controlFullscreenRestaurant = 0;
                                        $('body').removeClass('full-screen');
                                        $('.main-toolbar, #sidebar, #rightbar, #footer, #sidebar-resizer, #rightbar-resizer, .nav').removeClass('hide');
                                        $('.toggle-fullscreen-button').css({'background-position' :  ' 4px 9px'});
                                        $('#tabs md-tab-content').css({'min-height' :  'calc(100vh + 150px'});
                                     }
                        }
                        
                        
                        $scope.fullscreenRestaurant = function() {  
                                if  ($scope.controlFullscreenRestaurant == 0) {
                                         if (document.documentElement.requestFullscreen) {
                                                document.documentElement.requestFullscreen();
                                                document.addEventListener('fullscreenchange', closeFullscreen, false);
                                          } else if (document.documentElement.mozRequestFullscreen) {
                                                document.documentElement.mozRequestFullscreen();
                                                document.addEventListener('mozfullscreenchange', closeFullscreen, false);
                                         } else if (document.documentElement.webkitRequestFullscreen) {
                                                document.documentElement.webkitRequestFullscreen();
                                                document.addEventListener('webkitfullscreenchange', closeFullscreen, false);
                                         } else if (document.documentElement.msRequestFullscreen) {
                                                document.documentElement.msRequestFullscreen();
                                                document.addEventListener('msfullscreenchange', closeFullscreen, false);
                                         }
                                } else {
                                          if (document.exitFullscreen) {
                                                document.exitFullscreen();
                                            }   else if (document.mozCancelFullScreen) {
                                                document.mozCancelFullScreen();
                                            } else if (document.webkitExitFullscreen) {
                                                document.webkitExitFullscreen();
                                            }  else if (document.msExitFullscreen) {
                                                document.msExitFullscreen();
                                            }
                                }
                        }
                        
                         $scope.expandCollapseVertical = function() {  
                                var cardElement = angular.element(document.querySelector('.table-card table'));
                                if(cardElement[0].offsetHeight == 500){
                                        cardElement[0].style['height'] = '240px';
                                } else {
                                        cardElement[0].style['height'] = '500px';
                                }
                          }

                        
                if ($route.current.$$route.originalPath == $scope.path + '/serveRestaurant') {
                        /* mqtt */
                        Mqtt.addListener({ 'id': 'restaurant_table', 'funct': restaurantTable });
                        function restaurantTable(result, channel) {
                                //console.log(channel);
                                //console.log(result);
                                if (channel == 'restaurant_table_channel') {
                                        if (result.action == 'changeStatusTable') {

                                                if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                                        var positionRestaurant = $scope.additionals['restaurants'].map(function(e) {
                                                                return e['id'];
                                                        }).indexOf(parseInt(result['restaurant_id']));
                                                        if (positionRestaurant >= 0) {

                                                                if (!angular.isUndefined($scope.additionals['restaurants'][positionRestaurant]['tables'])) {
                                                                        var positionTable = $scope.additionals['restaurants'][positionRestaurant]['tables'].map(function(e) {
                                                                                return e['id'];
                                                                        }).indexOf(parseInt(result['id']));
                                                                        if (positionTable >= 0) {
                                                                                $scope.additionals['restaurants'][positionRestaurant]['tables'][positionTable]['table_status'] = result.table_status;
                                                                                $scope.additionals['restaurants'][positionRestaurant]['tables'][positionTable]['table_start'] = result.table_start;
                                                                                $scope.$apply();
                                                                        }
                                                                }
                                                        }
                                                }

                                        }

                                        if (result.action == 'store') {

                                                if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                                        var positionRestaurant = $scope.additionals['restaurants'].map(function(e) {
                                                                return e['id'];
                                                        }).indexOf(parseInt(result['restaurant_id']));
                                                        if (positionRestaurant >= 0) {
                                                                $scope.additionals['restaurants'][positionRestaurant]['tables'].push(result);
                                                                $scope.additionals['keepPositionTable'] ($scope.additionals['restaurants'][positionRestaurant]['tables']) ;
                                                                $scope.$apply();
                                                        }
                                                }
                                        }

                                        if (result.action == 'update') {
                                                if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                                        var positionRestaurant = $scope.additionals['restaurants'].map(function(e) {
                                                                return e['id'];
                                                        }).indexOf(parseInt(result['restaurant_id']));
                                                        if (positionRestaurant >= 0) {
                                                                if (!angular.isUndefined($scope.additionals['restaurants'][positionRestaurant]['tables'])) {
                                                                        var positionTable = $scope.additionals['restaurants'][positionRestaurant]['tables'].map(function(e) {
                                                                                return e['id'];
                                                                        }).indexOf(parseInt(result['id']));
                                                                        if (positionTable >= 0) {
                                                                                $scope.additionals['restaurants'][positionRestaurant]['tables'][positionTable]['table_title'] = result['table_title'];
                                                                                 $scope.additionals['restaurants'][positionRestaurant]['tables'][positionTable]['table_seats'] = result['table_seats'];
                                                                                $scope.$apply();
                                                                        }
                                                                }
                                                        }
                                                }
                                        }

                                        if (result.action == 'destroy') {
                                                if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                                        var positionRestaurant = $scope.additionals['restaurants'].map(function(e) {
                                                                return e['id'];
                                                        }).indexOf(parseInt(result['restaurant_id']));
                                                        if (positionRestaurant >= 0) {

                                                                if (!angular.isUndefined($scope.additionals['restaurants'][positionRestaurant]['tables'])) {
                                                                        var positionTable = $scope.additionals['restaurants'][positionRestaurant]['tables'].map(function(e) {
                                                                                return e['id'];
                                                                        }).indexOf(parseInt(result['id']));
                                                                        if (positionTable >= 0) {
                                                                                $scope.additionals['restaurants'][positionRestaurant]['tables'].splice(positionTable, 1);
                                                                                $scope.additionals['keepPositionTable'] ($scope.additionals['restaurants'][positionRestaurant]['tables']) ;
                                                                                $scope.$apply();
                                                                        }
                                                                }
                                                        }
                                                }

                                        }
                                }
                              
                        }

                        $scope.mode_action = 'dialog';

                        /* add single table */
                        $scope.addSingleTable = function(ev, path, restaurant_id, restaurant_key) {
                                ev.stopPropagation();
                                if ($scope.mode_action == 'dialog') {

                                        $scope.additionals['invalid'] = '';
                                        $scope.errors = {};
                                        $scope.action = 'store';
                                        $scope.modelData = {};

                                        $mdDialog.show({
                                                controller: DialogController,
                                                templateUrl: 'tableDialog.tmpl.html',
                                                parent: angular.element(document.body),
                                                targetEvent: ev,
                                                clickOutsideToClose: true,
                                                locals: {
                                                        pathTemplate: $scope.pathTemplate,
                                                        model: $scope.modelData,
                                                        additionals: $scope.additionals,
                                                        action: $scope.action
                                                }
                                        }).then(function() {
                                               
                                        });
                                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals', 'action'];
                                        function DialogController($scope, $mdDialog, pathTemplate, model, additionals, action) {
                                                $scope.pathTemplate = pathTemplate;
                                                $scope.modelData = model;
                                                $scope.additionals = additionals;
                                                $scope.action = action;

                                                $scope.cancel = function() {
                                                        $mdDialog.cancel();
                                                };

                                                if (!angular.isUndefined($scope.additionals['function'])) {
                                                        $scope.additionals['function'](ev, $scope.modelData);
                                                }

                                                $scope.saveModel = function() {
                                                        $scope.additionals['buttonDisabled'] = true;
                                                        if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                                                $scope.additionals['internFunction'](ev, $scope.modelData);
                                                        }
                                                        $scope.isLoading = true;

                                                        $scope.post = $scope.modelData;
                                                        $scope.post['restaurant_id'] = restaurant_id;
                                                        Crud.save($scope.additionals['content_type'], $scope.post, path)
                                                                .success(function(data) {
                                                                        if (!angular.isUndefined(data.invalid)) {
                                                                                $scope.additionals['invalid'] = data.invalid;
                                                                        } else {
                                                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                        $scope.additionals['functionResult'](ev, data);
                                                                                }
                                                                                if (!angular.isUndefined(data.currentModel)) {
                                                                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                                                }

                                                                        }
                                                                        $scope.isLoading = false;
                                                                        $mdDialog.hide();
                                                                        $scope.additionals['buttonDisabled'] = false;
                                                                })
                                                                .error(function(data) {
                                                                        $scope.isLoading = false;
                                                                        $scope.errors = data.errors;
                                                                        $scope.additionals['buttonDisabled'] = false;
                                                                        if (data == null) {
                                                                                $rootScope.checkNetworkConnection();
                                                                        }
                                                                });
                                                };

                                        }
                                }
                        };

                        /* update title table */
                        $scope.editSingleTable = function(ev, path, model, restaurant_key, table_key) {
                                ev.stopPropagation();
                                if ($scope.mode_action == 'dialog') {

                                        $scope.additionals['invalid'] = '';
                                        $scope.errors = {};
                                        $scope.action = 'update';
                                        var currentModel = {};

                                        angular.forEach(model, function(item, key) {
                                                currentModel[key] = item;
                                        });

                                        $mdDialog.show({
                                                controller: DialogController,
                                                templateUrl: 'editTableDialog.tmpl.html',
                                                parent: angular.element(document.body),
                                                targetEvent: ev,
                                                clickOutsideToClose: true,
                                                locals: {
                                                        pathTemplate: $scope.pathTemplate,
                                                        model: currentModel,
                                                        selected: $scope.selected,
                                                        additionals: $scope.additionals,
                                                        action: $scope.action
                                                }
                                        }).then(function() {
                                               
                                        });
                                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'selected', 'additionals', 'action'];
                                        function DialogController($scope, $mdDialog, pathTemplate, model, selected, additionals, action) {
                                                $scope.pathTemplate = pathTemplate;
                                                $scope.modelData = model;
                                                $scope.additionals = additionals;
                                                $scope.selected = selected;
                                                $scope.action = action;

                                                $scope.cancel = function() {
                                                        $mdDialog.cancel();
                                                };

                                                if (!angular.isUndefined($scope.additionals['function'])) {
                                                        $scope.additionals['function'](ev, $scope.modelData);
                                                }

                                                $scope.updateModel = function() {
                                                        $scope.additionals['buttonDisabled'] = true;
                                                        if (!angular.isUndefined($scope.additionals['internFunction'])) {
                                                                $scope.additionals['internFunction'](ev, $scope.modelData);
                                                        }
                                                        $scope.isLoading = true;

                                                        Crud.update($scope.additionals['content_type'], model, $rootScope.typeId, path)
                                                                .success(function(data) {
                                                                        if (!angular.isUndefined(data.invalid)) {
                                                                                $scope.additionals['invalid'] = data.invalid;
                                                                        } else {
                                                                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                        $scope.additionals['functionResult'](ev, data);
                                                                                }
                                                                                if (!angular.isUndefined(data.currentModel)) {
                                                                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                                                                }
                                                                        }
                                                                        $scope.isLoading = false;
                                                                        $mdDialog.hide();
                                                                        $scope.additionals['buttonDisabled'] = false;
                                                                })
                                                                .error(function(data) {
                                                                        $scope.isLoading = false;
                                                                        $scope.errors = data.errors;
                                                                        $scope.additionals['buttonDisabled'] = false;
                                                                        if (data == null) {
                                                                                $rootScope.checkNetworkConnection();
                                                                        }
                                                                });
                                                };

                                        }
                                }
                        };

                        /* delete table from restaurant */
                        $scope.deleteTable = function(ev, path, model, restaurant_key, table_key) {
                                ev.stopPropagation();
                                $scope.additionals['invalid'] = '';
                                $scope.modelData = {};
                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'deleteTableDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: { pathTemplate: $scope.pathTemplate, model: model, additionals: $scope.additionals }
                                }).then(function(destroyModel) {
                                        /*if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                         $scope.additionals['restaurants'][restaurant_key]['tables'].splice(table_key, 1);
                                         }*/
                                });

                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.cancel = function() {
                                                $mdDialog.cancel();
                                        };
                                        $scope.additionals = additionals;
                                        $scope.modelData = model;

                                        /* save a model */
                                        $scope.destroyModel = function() {
                                                $scope.additionals['buttonDisabled'] = true;
                                                $scope.isLoading = true;
                                                Crud.destroy(model.id, path)
                                                        .success(function(data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                } else {
                                                                        if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                                                                $scope.additionals['functionResult'](ev, data);
                                                                        }
                                                                }
                                                                $scope.isLoading = false;
                                                                $mdDialog.hide();
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function(data) {
                                                                $scope.errors = data.errors;
                                                                $scope.isLoading = false;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                                if (data == null) {
                                                                        $rootScope.checkNetworkConnection();
                                                                }
                                                        });
                                        };
                                }
                        };

                        /* update status table */
                        var inc = 0;
                        $scope.changeDisplay = function(typeDisplay, restaurant_key) {
                                                                         
                                if (angular.isUndefined($scope.gridSetting)) {
                                        $scope.gridSetting = [];
                                }
                                if (angular.isUndefined($scope.gridSetting['restaurant_key'])) {
                                        $scope.gridSetting['restaurant_key'] = {};
                                }

                                if (typeDisplay == 'grid') {
                                        $scope.gridSetting['restaurant_key'].typeDisplay = 'grid';
                                        $scope.gridSetting['restaurant_key'].cols_xs = 2;
                                        $scope.gridSetting['restaurant_key'].cols_sm = 4;
                                        $scope.gridSetting['restaurant_key'].cols_md = 5;
                                        $scope.gridSetting['restaurant_key'].cols_gt_md = 7;
                                        $scope.gridSetting['restaurant_key'].gutter = '10px';
                                        // $scope.gridSetting['restaurant_key'].row_height = '3:1.7';
                                        $scope.gridSetting['restaurant_key'].row_height = '100';
                                }
                                if (typeDisplay == 'line') {
                                        $scope.gridSetting['restaurant_key'].typeDisplay = 'line';
                                        $scope.gridSetting['restaurant_key'].cols_xs = 1;
                                        $scope.gridSetting['restaurant_key'].cols_sm = 1;
                                        $scope.gridSetting['restaurant_key'].cols_md = 1;
                                        $scope.gridSetting['restaurant_key'].cols_gt_md = 1;
                                        $scope.gridSetting['restaurant_key'].gutter = '20px';
                                        $scope.gridSetting['restaurant_key'].row_height = '100';
                                }
                                
                                inc++;
                                var incH = '0.000000'+inc;
                                if(inc == 2){
                                     inc = 0;
                                } 
                                $scope.gridSetting['restaurant_key'].row_height = parseFloat($scope.gridSetting['restaurant_key'].row_height) +parseFloat(incH) ;
                
                        }
                        $scope.changeDisplay('grid', 0);

                        $scope.openTable = function(ev, table) {
                                ev.stopPropagation();

                                var tableElement = angular.element(document.querySelector('#table-' + table.id));
                                var tableHeader = angular.element(document.querySelector('#table-'  + table.id + ' .grid-header'));
                                var tableContent = angular.element(document.querySelector('#table-' + table.id + '  .table-content'));
                                var tableHeaderOpened = angular.element(document.querySelector('#table-'  + table.id + ' .grid-header-opened'));

                                tableHeader.removeClass('hide');
                                tableContent.removeClass('hide');
                                tableHeaderOpened.addClass('hide');

                                tableElement[0].style['max-width'] = 'unset';
                                tableElement[0].style['padding-block'] = '';
                                tableElement[0].style['max-height'] = '';

                                /*var set = $scope.gridSetting['restaurant_key'].row_height.split(':');
                                var setParam = parseFloat(set[1]) + parseFloat(0.0000001);
                                $scope.gridSetting['restaurant_key'].row_height = set[0]+':'+setParam;
                                console.log($scope.gridSetting['restaurant_key'].row_height)*/

                        }
                        
                        $scope.closeTable = function(ev, table) {
                                ev.stopPropagation();
                        
                                var tableElement = angular.element(document.querySelector('#table-' + table.id));
                                var tableHeader = angular.element(document.querySelector('#table-' + table.id + ' .grid-header'));
                                var tableContent = angular.element(document.querySelector('#table-' +  table.id + ' .table-content'));
                                var tableHeaderOpened = angular.element(document.querySelector('#table-' + table.id + ' .grid-header-opened'));
                        
                                tableHeader.addClass('hide');
                                tableContent.addClass('hide');
                                tableHeaderOpened.removeClass('hide');
                        
                                tableElement[0].style['max-width'] = '100px';
                                tableElement[0].style['max-height'] = '0px';
                                tableElement[0].style['padding-block'] = '0px';
                        }

                        $scope.collapseTable = function(ev, table) {
                                ev.stopPropagation();
                        
                                var tableElement = angular.element(document.querySelector('#table-' + table.id));
                                var tableContent = angular.element(document.querySelector('#table-' + table.id + ' .table-content'));
                                var tableContentIcon = angular.element(document.querySelector('#table-' + table.id+ ' i.collapse-table'));
                        
                                tableContent.slideToggle('200', function() {
                                                tableContentIcon.toggleClass('fa-plus fa-minus');
                                
                                                if (tableContentIcon.hasClass('fa-plus') ) {
                                                tableElement[0].style['padding-block'] = '0px';
                                                tableElement[0].style['max-height'] = '0px';
                                        } else {
                                                tableElement[0].style['padding-block'] = '';
                                                tableElement[0].style['max-height'] = '';
                                        }
                                });
                        
                         }
                        
                        $scope.changeStatusTable = function(ev, path, model, restaurant_key, table_key) {
                        
                                ev.stopPropagation();
                        
                                $scope.isLoading = true;
                                var typeRequest = 'form-urlencoded';
                                var post = {};
                                post['route'] = 'changeStatusTable';
                                post['table_status'] = model['table_status'];
                                post['id'] = model.id;
                                Crud.post(typeRequest, post, path + '/changeStatusTable')
                                        .success(function(data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                        $scope.additionals['invalid'] = data.invalid;
                                                } else {
                                                        if (!angular.isUndefined(data.currentModel)) {
                                                                /*$scope.additionals['dataCurrentModel'] = data.currentModel;
                                                                 if (!angular.isUndefined($scope.additionals['restaurants'])) {
                                                                 $scope.additionals['restaurants'][restaurant_key]['tables'][table_key]['table_status'] = $scope.additionals['dataCurrentModel']['table_status'];
                                                                 }*/
                                                        }
                                                }
                                                $scope.isLoading = false;
                        
                                        })
                                        .error(function(data) {
                                                $scope.errors = data.errors;
                                                $scope.isLoading = false;
                                        });

                                }

                                $scope.controlToggleText = 0;
                                $scope.toggleText = function() {
                                        if ($scope.controlToggleText == 0) {
                                                $scope.controlToggleText = 1;
                                        } else {
                                                $scope.controlToggleText = 0;
                                        }
                                }
                                
                                $scope.changeTabRestaurant = function(keyRestaurant) {
                                        $scope.additionals['keepPositionTable']($scope.additionals['restaurants'][keyRestaurant]['tables']);
                                        $scope.keyTable = keyRestaurant;
                                        if (angular.isUndefined($scope.actionOrder)) {
                                                $scope.actionOrder = [];
                                        }
                                        if (angular.isUndefined($scope.actionOrder[$scope.keyTable])) {
                                                $scope.actionOrder[$scope.keyTable] = 'store';
                                        }
                                        
                                         if (angular.isUndefined($scope.controlSearchOrder)) {
                                                $scope.controlSearchOrder = [];
                                        }
                                        if (angular.isUndefined($scope.controlSearchOrder[keyRestaurant])) {
                                                $scope.controlSearchOrder[keyRestaurant] = 0;
                                        }
                
                                }

                                $scope.additionals['keepPositionTable'] = function(tables) {
                                       $timeout(function() {
                                                if (!angular.isUndefined(tables)) {
                                                        angular.forEach(tables, function(itemTable, keyTable) {
                                                                var tableElement = angular.element(document.querySelector('#table-' + itemTable.id));
                                                                if (!angular.isUndefined(tables[keyTable]['table_x']) && !angular.isUndefined(tables[keyTable]['table_y']) && tables[keyTable]['table_x'] != 0 && tables[keyTable]['table_y'] != 0) {
                                                                        tableElement[0].style.left = tables[keyTable]['table_x'];
                                                                        tableElement[0].style.top = tables[keyTable]['table_y'];
                                                                }
                                                                tableElement[0].style.width = '150px';
                                                        });
                                                }
                                       }, 200);
                                }
                                                  
                                $scope.additionals['getRestaurants'] = function() {
                                        Crud.get($scope.path + '/getRestaurants')
                                                .success(function(data) {
                                                        $scope.additionals['restaurants'] = data;
                                                        //$scope.additionals['keepPositionTable'] (data[0]['tables']) ;
                                                });
                                }
                                $scope.additionals['getRestaurants']();
                                              
                                $scope.additionals['addTableOrder'] = function(ev, path, model, restaurant_id,  restaurant_key, table_key) {
                                        /*console.log($route);
                                         console.log($location);
                                         console.log($routeParams);*/
                                
                                        //console.log($location.protocol() +'/'+ $location.host());
                                        //$window.open($location.absUrl() + '/11', '_blank');
                                        
                                         $scope.changeStatusTable(ev, path, model, restaurant_key, table_key) ;
                                
                                        $window.open($scope.path + '/serveRestaurant/' + restaurant_id + '-' + table_key, '_blank');
                                }
                                
                                $scope.timer = function(date) {
                                        var start = date;
                                        var end = moment();
                                
                                        var duration = moment.duration(end.diff(start));
                                        return moment.utc(duration.as('milliseconds')).format('HH:mm:ss');
                                }
                                
                                $scope.currentDate = moment().format('DD MMM');
                                var midnight = "11:59:59 pm";
                                var now = null;
                                $rootScope.stopTimer = $interval(function() {
                                        $scope.timer();
                                        /*now = moment().format("h:mm:ss a");
                                         if (now === midnight) {
                                         $scope.currentDate = moment().add(1, 'days').format('DD MMM');
                                         }*/
                                }, 1000);
                                
                  }

/* restaurant tables */
if ($route.current.$$route.originalPath.split(':')[0] == $scope.path + '/serveRestaurant/' || $route.current.$$route.originalPath == $scope.path + '/serveRestaurant') {
          if (!angular.isUndefined($routeParams.id)) {
                var idArray = $routeParams.id.split('-');
                 $scope.tables = 1;
          } else {                
                $scope.tables = 0;
                var idArray = ["0", "0"];
                $scope.keyTable = 0;
        }

        $scope.modelOrderName = 'order';
        $scope.pathOrder = 'order';
        var perPageOrder =10;

        if($scope.tables == 0){
                $scope.columnsOrder = {
                        'order_no': { 'label': 'Nr.com.', 'filter': 1, 'filterType': 'input' },
                        'client_name': { 'label': 'Client', 'filter': 1, 'filterType': 'input' },
                        'order_phone': { 'label': 'Telefon', 'filter': 1, 'filterType': 'input' },
                        'order_start': { 'label': 'Start', 'filter': 1, 'filterType': 'input' },
                        'order_end': { 'label': 'End', 'filter': 1, 'filterType': 'input' },
                        'order_status': { 'label': 'Status', 'filter': 1, 'filterType': 'select' },
                        'order_amount': { 'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        //'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                        'order_product_discount': { 'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        'order_client_discount': { 'label': 'Discount client (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        //'order_loyalty_point_discount': { 'label': 'Discount pct. fidelizare (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        'order_total': {'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' }
                       }
       }
       if($scope.tables == 1){
                $scope.columnsOrder = {
                        'order_no': { 'label': 'Nr.com.', 'filter': 1, 'filterType': 'input' },
                        'order_start': { 'label': 'Start', 'filter': 1, 'filterType': 'input' },
                        'order_end': { 'label': 'End', 'filter': 1, 'filterType': 'input' },
                        'order_status': { 'label': 'Status', 'filter': 1, 'filterType': 'select' },
                        'order_amount': { 'label': 'Total produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        //'order_packaging': {'label': 'Cost ambalaj (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input', 'nonDisplay': $scope.nonDisplay},
                        'order_product_discount': { 'label': 'Discount produse (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        'order_discount': {'label': 'Discount comanda (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' },
                        'order_total': { 'label': 'Total (' + $rootScope.currency + ')', 'filter': 1, 'filterType': 'input' }
                       }
       }
        
        $scope.columnsOrder.order_status.options = [
                { 'id': 1, 'value': 'Derulare', 'color': 'rgba(242, 237, 86, 0.9)', 'color-even': 'rgba(242, 237, 86, 0.7)' }, //yellow
                { 'id': 2, 'value': 'Anulata', 'color': 'rgba(193, 32, 38, 0.7)', 'color-even': 'rgba(193, 32, 38, 0.5)' }, //red
                { 'id': 3, 'value': 'Trimisa spre livrare', 'color': 'rgba(222, 96, 27, 0.5)', 'color-even': 'rgba(222, 96, 27, 0.3)' }, //brown
                { 'id': 4, 'value': 'Curs de livrare', 'color': 'rgba(169, 215, 65, 0.9)', 'color-even': 'rgba(169, 215, 65, 0.7)' }, //green
                { 'id': 5, 'value': 'Livrata', 'color': 'rgba(0, 51, 153, 0.4)', 'color-even': 'rgba(0, 51, 153, 0.2)' }, //blue
                { 'id': 6, 'value': 'Anulata ospatar', 'color': 'rgba(90, 87, 87, 0.8)', 'color-even': 'rgba(90, 87, 87, 0.6)' }//black
        ];
        $scope.additionals['order_status'] = $scope.columnsOrder.order_status.options;
        $scope.additionals['columnsOrder'] = $scope.columnsOrder;
        
        $scope.additionals['discount_types'] = [
                { 'id': '', 'value': '' },
                { 'id': 0, 'value': 'procent', 'mark': '%' },
                { 'id': 1, 'value': 'suma fixa', 'mark': '' }
        ];
        $scope.additionals['discount_type'] = {};
        $scope.additionals['discount_type'].options = $scope.additionals['discount_types'];

        $scope.additionals['discount_campaign_value_type'] = {};
        $scope.additionals['discount_campaign_value_type'].options = $scope.additionals['discount_types'];
        $scope.additionals['discount_campaign_types'] = [
                { 'id': '', 'value': '' },
                { 'id': 0, 'value': 'Reducere one-time' },
                { 'id': 1, 'value': 'Reducere multipla' }
        ];
        $scope.additionals['discount_campaign_type'] = {};
        $scope.additionals['discount_campaign_type'].options = $scope.additionals['discount_campaign_types'];

        $scope.additionals['type_orders'] = [
                { 'value': 'order_active', 'name': 'Comenzi active' },
                { 'value': 'order_cancelled', 'name': 'Comenzi anulate' }
        ];
        $scope.additionals['type_orders_incident'] = [
                { 'value': 0, 'name': 'Comenzi fara incident' },
                { 'value': 1, 'name': 'Comenzi cu incident' },
                { 'value': 2, 'name': 'Comenzi generate de incident' }
        ];

        $scope.additionals['generateKeyboard'] = function() {
                if (angular.isUndefined($scope.additionals['rangeKeyboard'])) {
                        $scope.additionals['rangeKeyboard'] = {};
                }
                for (var i = 0; i <= 9; i++) {
                       $scope.additionals['rangeKeyboard'][i] = i;
                 }
                 $scope.additionals['rangeKeyboard'][11] = '.';
                 $scope.additionals['rangeKeyboard'][12] = 'Clear';
        }
        $scope.additionals['generateKeyboard']();
        $scope.additionals['getKey'] = function(valueKeyboard) {
                if (!angular.isUndefined($rootScope.focusedElement)) {
                        if(valueKeyboard != 'Clear'){
                                $rootScope.focusedElement[0].value += valueKeyboard;
                         } else {
                                $rootScope.focusedElement[0].value = '';
                        }
                        angular.element($rootScope.focusedElement[0]).triggerHandler('input');
                }
         }
        
        $scope.additionals['orderProductsByClients'] = function(keyTable) {
                $scope.modelDataOrder[keyTable]['food_products'] = $filter('orderBy')($scope.modelDataOrder[keyTable]['food_products'], 'food_product_client_seat');
        }
          
         $scope.additionals['generateSeats'] = function(no_tables, keyTable) {
                 if (angular.isUndefined($scope.additionals['rangeSeats'])) {
                                $scope.additionals['rangeSeats'] = [];
                }
                if (angular.isUndefined($scope.additionals['rangeSeats'][keyTable])) {
                                $scope.additionals['rangeSeats'][keyTable] = [];
                }
                for (var i = 0; i < no_tables; i++) {
                        var j = i+1;
                            $scope.additionals['rangeSeats'][keyTable][i] = 'Loc_'+j;
                 }
         }
                
        $scope.additionals['getTablesByRestaurant'] = function() { 
                $scope.idRestaurant = idArray[0];
                Crud.get($scope.path + '/getTablesByRestaurant/' + $scope.idRestaurant)
                        .success(function(data) {
                                if (!angular.isUndefined(idArray[1])) {
                                        $scope.selectedIndex = idArray[1];
                          
                                        var keyTable = idArray[1];
                                        $scope.additionals['generateSeats'](data.restaurant.tables[keyTable]['table_seats'], keyTable);
                                                                                                                   
                                        $scope.idTable = data.restaurant.tables[keyTable]['id'];
                                        $scope.additionals['restaurant'] = data.restaurant;
                                        $scope.additionals['settings'] = data.settings;
                                        $scope.additionals['discounts'] = data.discounts;
        
                                        $scope.additionals['payment_methods'] = data.paymentMethods;
        
                                        if (!angular.isUndefined($scope.columnsOrder.payment_method_name)) {
                                                $scope.columnsOrder.payment_method_name.options = [{ id: '', value: '' }];
                                                angular.forEach(data.paymentMethods, function(item, key) {
                                                        $scope.columnsOrder.payment_method_name.options.push({
                                                                id: item.payment_method_name,
                                                                value: item.payment_method_name
                                                        });
                                                });
                                        }
        
                                        $scope.additionals['functionOrder']('', [], keyTable);
                                        $scope.additionals['getFoodCategories'](keyTable);
                                        $scope.getOrders($scope.pathOrder, 1, perPageOrder);
                                        if($scope.tables == 1){
                                                $scope.getLastOrderTable($scope.pathOrder, keyTable);
                                        }
                                              
                                }
                        });
        }


        $scope.changeTab = function(tableId) {
                var keyTable = $scope.selectedIndex;

                if (angular.isUndefined($scope.actionOrder)) {
                        $scope.actionOrder = [];
                }
                if (angular.isUndefined($scope.actionOrder[keyTable])) {
                        $scope.actionOrder[keyTable] = 'store';
                }

                if (angular.isUndefined($scope.actionOrderSec)) {
                        $scope.actionOrderSec = [];
                }
                if (angular.isUndefined($scope.searchOrder)) {
                        $scope.searchOrder = [];
                }
                if (angular.isUndefined($scope.searchOrder[keyTable])) {
                        $scope.searchOrder[keyTable] = {};
                }
                if (angular.isUndefined($scope.controlSearchOrder)) {
                        $scope.controlSearchOrder = [];
                }
                if (angular.isUndefined($scope.controlSearchOrder[keyTable])) {
                        $scope.controlSearchOrder[keyTable] = 0;
                }
                if (angular.isUndefined($scope.controlShowOrder)) {
                        $scope.controlShowOrder = [];
                }
                if (angular.isUndefined($scope.controlShowOrder[keyTable])) {
                        $scope.controlShowOrder[keyTable] = 0;
                }

                if (angular.isUndefined($scope.modelDataOrder)) {
                        $scope.modelDataOrder = [];
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                        $scope.modelDataOrder[keyTable] = {};
                }
                if (!angular.isUndefined(tableId)) {
                        $scope.idTable = tableId;
                        $scope.additionals['generateSeats']($scope.additionals['restaurant']['tables'][keyTable]['table_seats'], keyTable);
                        $scope.getOrders($scope.pathOrder, 1, perPageOrder);
                }
                
        }

        /*search order*/
        if (angular.isUndefined($scope.searchOrder)) {
                $scope.searchOrder = [];
        }
        if (angular.isUndefined($scope.controlSearchOrder)) {
                $scope.controlSearchOrder = [];
        }
        $scope.toggleSearch = function(ev, keyTable) {
                if (angular.isUndefined($scope.searchOrder)) {
                        $scope.searchOrder = [];
                }
                if (angular.isUndefined($scope.searchOrder[keyTable])) {
                        $scope.searchOrder[keyTable] = {};
                }
                if (angular.isUndefined($scope.controlSearchOrder)) {
                        $scope.controlSearchOrder = [];
                }
                if (angular.isUndefined($scope.controlSearchOrder[keyTable])) {
                        $scope.controlSearchOrder[keyTable] = 0;
                }

                $scope.searchOrder[keyTable].dateFrom = current_init_date;
                if ($scope.controlSearchOrder[keyTable] == 0) {
                        $scope.controlSearchOrder[keyTable] = 1;
                        $scope.searchOrder[keyTable].dateFrom = current_init_date;
                } else {
                        $scope.controlSearchOrder[keyTable] = 0;
                }
        }

        $scope.cancelSearchOrder = function(ev, pathOrder, keyTable) {
                $scope.searchOrder[keyTable] = {};
                if ($scope.controlSearchOrder[keyTable] == 1) {
                        $scope.getOrders(pathOrder, 1, perPageOrder);
                }
                angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
                angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
                var form = document.getElementById('search-form-'+keyTable);
                form.reset();
        }

        if (angular.isUndefined($scope.additionals['on'])) {
                $scope.additionals['on'] = [];
        }
        //$scope.additionals['on'][keyTable] = false;

        if (angular.isUndefined($scope.additionals['controlSupplements'])) {
                $scope.additionals['controlSupplements'] = [];
        }
        
        $scope.additionals['changePayment'] = function(keyTable, method_payment_id, modelDataOrder, keyPayment) {
                
                if (method_payment_id == 1) {
                        if (!angular.isUndefined(keyPayment)) {  
                                $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_card = $scope.formatDecimal(parseFloat(modelDataOrder['payments'][keyPayment].payment_total) - parseFloat(modelDataOrder['payments'][keyPayment].payment_cash));
                        } else {
                                $scope.modelDataOrder[keyTable].payment_card = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable]['order_total'])- parseFloat(modelDataOrder.payment_cash));
                                angular.forEach($scope.modelDataOrder[keyTable]['payments'], function(itemPayment, indexPayment) {
                                        if ($scope.modelDataOrder[keyTable]['payments'][indexPayment].payment_check == true) {
                                                $scope.modelDataOrder[keyTable].payment_card = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable].payment_cash) - parseFloat(itemPayment['payment_total']));
                                        }
                                });
                                if ($scope.modelDataOrder[keyTable].payment_cash < 0 || $scope.modelDataOrder[keyTable].payment_card < 0) {
                                        $scope.modelDataOrder[keyTable].payment_card = 0;
                                }

                        }
                }
                if (method_payment_id == 2) {  
                        if (!angular.isUndefined(keyPayment)) {
                                $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_cash = $scope.formatDecimal(parseFloat(modelDataOrder['payments'][keyPayment].payment_total) - parseFloat(modelDataOrder['payments'][keyPayment].payment_card));

                                if ($scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_cash < 0 || $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_cash < 0) {
                                        $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_card = 0;
                                        $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_cash = $scope.formatDecimal(parseFloat(modelDataOrder['payments'][keyPayment].payment_total));
                                }
                        } else {
                                $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable]['order_total']) - parseFloat(modelDataOrder.payment_card));
                                var total_clients = 0;
                                angular.forEach($scope.modelDataOrder[keyTable]['payments'], function(itemPayment, indexPayment) {
                                        if ($scope.modelDataOrder[keyTable]['payments'][indexPayment].payment_check == true) {
                                                total_clients = total_clients + parseFloat(itemPayment['payment_total']);
                                        }
                                });
                                $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable].payment_cash) - parseFloat(total_clients));

                                if ($scope.modelDataOrder[keyTable].payment_cash < 0 || $scope.modelDataOrder[keyTable].payment_card < 0) {
                                        $scope.modelDataOrder[keyTable].payment_card = 0;
                                        $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable]['order_total']) - parseFloat(total_clients));
                                }

                        }
                }
               
        }

        $scope.additionals['selectClient'] = function(keyTable, modelDataOrder, keyPayment) {
                if (angular.isUndefined(modelDataOrder['payments'])) {
                        modelDataOrder['payments'] = [];
                }
                if (angular.isUndefined(keyPayment)) {
                        if (angular.isUndefined(modelDataOrder['payments'][keyPayment])) {
                                modelDataOrder['payments'][keyPayment] = {};
                        }
                        if (angular.isUndefined(modelDataOrder['payments'][keyPayment].payment_card)) {
                                modelDataOrder['payments'][keyPayment].payment_card = 0;
                        }
                }
                if ($scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_check == true) {
                        $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable].payment_cash) - parseFloat(modelDataOrder['payments'][keyPayment].payment_cash) - parseFloat(modelDataOrder['payments'][keyPayment].payment_card));
                        if ($scope.modelDataOrder[keyTable].payment_cash < 0) {
                                $scope.modelDataOrder[keyTable].payment_card = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable].payment_card) + parseFloat($scope.modelDataOrder[keyTable].payment_cash));
                                $scope.modelDataOrder[keyTable].payment_cash = 0;
                        }
                }
                if ($scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_check == false) {
                        $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_card = 0;
                        $scope.modelDataOrder[keyTable]['payments'][keyPayment].payment_cash = $scope.formatDecimal(modelDataOrder['payments'][keyPayment].payment_total);
                        $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable].payment_cash) + parseFloat(modelDataOrder['payments'][keyPayment].payment_cash));
                }
        }

        $scope.additionals['functionOrder'] = function(ev, data, keyTable) {
       
                if (angular.isUndefined($scope.actionOrder)) {
                        $scope.actionOrder = [];
                 }
                if (angular.isUndefined($scope.actionOrder[keyTable])) {
                        $scope.actionOrder[keyTable] = 'store';
                }
                 if (angular.isUndefined($scope.modelDataOrder)) {
                        $scope.modelDataOrder = [];
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                        $scope.modelDataOrder[keyTable] = {};
                }
                if (angular.isUndefined($scope.actionOrder)) {
                        $scope.actionOrder = [];
                }
                if (angular.isUndefined($scope.actionOrderSec)) {
                        $scope.actionOrderSec = [];
                }
        
                if (angular.isUndefined($scope.additionals['searchTermCategory'])) {
                        $scope.additionals['searchTermCategory'] = [];
                }
                if (angular.isUndefined($scope.additionals['searchTermProduct'])) {
                        $scope.additionals['searchTermProduct'] = [];
                }
                if (angular.isUndefined($scope.additionals['searchTermSupplement'])) {
                        $scope.additionals['searchTermSupplement'] = [];
                }
                $scope.additionals['searchTermCategory'][keyTable] = '';
                $scope.additionals['searchTermProduct'][keyTable] = '';
                $scope.additionals['searchTermSupplement'][keyTable] = '';

                if (angular.isUndefined($scope.additionals['total_product'])) {
                        $scope.additionals['total_product'] = [];
                }
                $scope.additionals['total_product'][keyTable] = 0;

                if (angular.isUndefined($scope.additionals['total_product_discount'])) {
                        $scope.additionals['total_product_discount'] = [];
                }
                $scope.additionals['total_product_discount'][keyTable] = 0;

                if (angular.isUndefined($scope.additionals['total_client_discount'])) {
                        $scope.additionals['total_client_discount'] = [];
                }
                $scope.additionals['total_client_discount'][keyTable] = 0;

                if (angular.isUndefined($scope.additionals['total_loyalty_point_discount'])) {
                        $scope.additionals['total_loyalty_point_discount'] = [];
                }
                $scope.additionals['total_loyalty_point_discount'][keyTable] = 0;

                if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                        $scope.modelDataOrder[keyTable] = {};
                }
                /* payments */
               
                if (angular.isUndefined($scope.modelDataOrder[keyTable].payment_cash)) {
                        if (!angular.isUndefined($scope.modelDataOrder[keyTable]['order_total'])) { 
                                $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable]['order_total']));
                        } else {
                                $scope.modelDataOrder[keyTable].payment_cash = 0;
                        }
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable].payment_card)) {
                        $scope.modelDataOrder[keyTable].payment_card = 0;
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable]['payments'])) {
                        $scope.modelDataOrder[keyTable]['payments'] = [];
                }

                if (!angular.isUndefined($scope.modelDataOrder[keyTable]['food_products'])) {
                        if ($scope.modelDataOrder[keyTable]['food_products'].length > 0) {
                                var groups = $scope.additionals['groupArrayByProp']($scope.modelDataOrder[keyTable]['food_products'], 'food_product_client_seat');
                                var noGroup = 0;
                                  angular.forEach(groups, function(itemGroup, indexGroup) {
                                        if (angular.isUndefined($scope.modelDataOrder[keyTable]['payments'][noGroup])) {
                                                $scope.modelDataOrder[keyTable]['payments'][noGroup] = {};
                                        }

                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_seat'] = indexGroup;

                                        var payment_total = 0;
                                        angular.forEach(itemGroup, function(itemProduct, indexProduct) {
                                                if (angular.isUndefined(itemProduct['order_food_product_discount_value'])) {
                                                       itemProduct['order_food_product_discount_value'] = 0;
                                                }
                                                payment_total = payment_total + itemProduct['food_product_quantity'] * (parseFloat(itemProduct['food_product_price'] ) - parseFloat(itemProduct['order_food_product_discount_value']));
                                                
                                                if (!angular.isUndefined(itemProduct['food_supplements'])) {
                                                          angular.forEach(itemProduct['food_supplements'], function(itemSupplement, indexSupplement) {
                                                                if (angular.isUndefined(itemSupplement['order_supplement_discount_value'] )) {
                                                                        itemSupplement['order_supplement_discount_value'] = 0;
                                                                }
                                                                payment_total = payment_total + itemProduct['food_product_quantity'] * (parseFloat(itemSupplement['supplement_price']) - parseFloat(itemSupplement['order_supplement_discount_value']));

                                                        });
                                                }
                                        });
                                       
                                         if (angular.isUndefined($scope.modelDataOrder[keyTable].order_product_discount)) {
                                                $scope.modelDataOrder[keyTable].order_product_discount = 0;
                                         }
                                        var part = payment_total * 100 / ($scope.modelDataOrder[keyTable].order_amount - $scope.modelDataOrder[keyTable].order_product_discount);
                                        
                                        if (angular.isUndefined($scope.modelDataOrder[keyTable].order_client_discount)) {
                                                $scope.modelDataOrder[keyTable].order_client_discount = 0;
                                        }
                                        if (angular.isUndefined($scope.modelDataOrder[keyTable].order_loyalty_point_discount)) {
                                                $scope.modelDataOrder[keyTable].order_loyalty_point_discount = 0;
                                        }
                                       if (angular.isUndefined($scope.modelDataOrder[keyTable].order_discount) || $scope.modelDataOrder[keyTable].order_discount =='') {
                                                $scope.modelDataOrder[keyTable].order_discount = 0;
                                        }
                                        
                                        payment_total = $scope.formatDecimal(payment_total - part * (parseFloat($scope.modelDataOrder[keyTable].order_client_discount) + parseFloat($scope.modelDataOrder[keyTable].order_loyalty_point_discount) + parseFloat($scope.modelDataOrder[keyTable].order_discount)) / 100);
 
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_total'] = payment_total;
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_cash'] = payment_total;
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_card'] = 0;

                                        if (!angular.isUndefined($scope.modelDataOrder[keyTable]['payments_order'])) {
                                                var positionClient = $scope.modelDataOrder[keyTable]['payments_order'].map(function(e) {
                                                        return e['payment_seat'];
                                                }).indexOf(indexGroup);
                                                if (positionClient >= 0) {
                                                        $scope.modelDataOrder[keyTable]['payments'][noGroup] = $scope.modelDataOrder[keyTable]['payments_order'][positionClient];
                                                }
                                        }
                                        noGroup++;
                                });

                        }
                }
                /* end payments */

                $scope.modelDataOrder[keyTable].product_errors = '';

                if ($scope.modelDataOrder[keyTable]['client_gdpr'] == 0) {
                        $scope.modelDataOrder[keyTable].client_gdpr = false;
                }
                if ($scope.modelDataOrder[keyTable]['client_gdpr'] == 1) {
                        $scope.modelDataOrder[keyTable].client_gdpr = true;
                }
                if ($scope.modelDataOrder[keyTable]['client_cutlery'] == 0) {
                        $scope.modelDataOrder[keyTable].client_cutlery = false;
                }
                if ($scope.modelDataOrder[keyTable]['client_cutlery'] == 1) {
                        $scope.modelDataOrder[keyTable].client_cutlery = true;
                }
                if ($scope.modelDataOrder[keyTable]['order_cutlery'] == 0) {
                        $scope.modelDataOrder[keyTable].order_cutlery = false;
                }
                if ($scope.modelDataOrder[keyTable]['order_cutlery'] == 1) {
                        $scope.modelDataOrder[keyTable].order_cutlery = true;
                }

                if (angular.isUndefined($scope.additionals['loyalty_point_accumulated'])) {
                        $scope.additionals['loyalty_point_accumulated'] = [];
                }
                if (angular.isUndefined($scope.additionals['discount_campaigns'])) {
                        $scope.additionals['discount_campaigns'] = [];
                }
                $scope.additionals['loyalty_point_accumulated'][keyTable] = data.loyalty_point_accumulated;
                if ($scope.actionOrder[keyTable] == 'store') {
                        $scope.additionals['discount_campaigns'][keyTable] = [];
                }
                if ($scope.actionOrder[keyTable] == 'update') {
                        $scope.additionals['clients'] = [{}];
                        if (!angular.isUndefined(data.client_first_name)) {
                                $scope.additionals['clients'][0].client_first_name = data.client_first_name;
                                $scope.additionals['clients'][0].value = data.client_first_name;
                        }
                        if (!angular.isUndefined(data.client_last_name)) {
                                $scope.additionals['clients'][0].client_last_name = data.client_last_name;
                                $scope.additionals['clients'][0].value = data.client_last_name;
                        }
                        if (!angular.isUndefined(data.client_first_name) && !angular.isUndefined(data.client_last_name)) {
                                $scope.additionals['clients'][0].value = data.client_first_name + ' ' + data.client_last_name;
                        }
                        $scope.additionals['clients'][0].client_phone = data.order_phone;
                        $scope.additionals['clients'][0].id = data.client_id;
                        $scope.additionals['clients'][0].address = data.address;
                }

                if (angular.isUndefined($scope.modelDataOrder[keyTable].order_packets) || $scope.modelDataOrder[keyTable].order_packets == null) {
                        $scope.modelDataOrder[keyTable].order_packets = 1;
                }

                $scope.additionals['controlMentionProduct'] = [];
                 $scope.additionals['controlMentionProductSec'] = [];
                $scope.additionals['controlClientProduct'] = [];

                $scope.additionals['controlSupplements'][keyTable] = false;
                $scope.additionals['total_product'][keyTable] = 0;
                if (angular.isUndefined($scope.controlShowOrder)) {
                        $scope.controlShowOrder = [];
                }
                if (angular.isUndefined($scope.controlShowOrder[keyTable])) {
                        $scope.controlShowOrder[keyTable] = 0;
                }
                $scope.cancelShowOrder = function(keyTable) {
                        $scope.controlShowOrder[keyTable] = 0;
                }

                $scope.errors = {};
        }
        
        $scope.additionals['updatePayments'] = function(keyTable) { 
                
                /* update payments */
                $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal($scope.modelDataOrder[keyTable]['order_total']);
                 $scope.modelDataOrder[keyTable].payment_card = 0;
                if (angular.isUndefined($scope.modelDataOrder[keyTable]['payments'])) {
                        $scope.modelDataOrder[keyTable]['payments'] = [];
                }

                if (!angular.isUndefined($scope.modelDataOrder[keyTable]['food_products'])) {
                        if ($scope.modelDataOrder[keyTable]['food_products'].length > 0) {
                                var groups = $scope.additionals['groupArrayByProp']($scope.modelDataOrder[keyTable]['food_products'], 'food_product_client_seat');
                                var noGroup = 0;
                                
                                angular.forEach(groups, function(itemGroup, indexGroup) {
                                        if (angular.isUndefined($scope.modelDataOrder[keyTable]['payments'][noGroup])) {
                                                $scope.modelDataOrder[keyTable]['payments'][noGroup] = {};
                                        }
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup].payment_check = false;

                                        if (angular.isUndefined($scope.modelDataOrder[keyTable]['payments'][noGroup])) {
                                                $scope.modelDataOrder[keyTable]['payments'][noGroup] = {};
                                        }
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_seat'] = indexGroup;

                                        var payment_total = 0;
                                        angular.forEach(itemGroup, function(itemProduct, indexProduct) {
                                                if (angular.isUndefined(itemProduct['order_food_product_discount_value'])) {
                                                       itemProduct['order_food_product_discount_value'] = 0;
                                                }
                                                payment_total = payment_total + itemProduct['food_product_quantity'] * (parseFloat(itemProduct['food_product_price']) - parseFloat(itemProduct['order_food_product_discount_value']));
                                                
                                                if (!angular.isUndefined(itemProduct['food_supplements'])) {
                                                        angular.forEach(itemProduct['food_supplements'], function(itemSupplement, indexSupplement) {
                                                                if (angular.isUndefined(itemSupplement['order_supplement_discount_value'] )) {
                                                                        itemSupplement['order_supplement_discount_value'] = 0;
                                                                }
                                                                payment_total = payment_total + itemProduct['food_product_quantity'] * (parseFloat(itemSupplement['supplement_price']) - parseFloat(itemSupplement['order_supplement_discount_value']));
                                                                
                                                        });
                                                }
                                        });

                                        var part = payment_total * 100 / ($scope.additionals['total_product'][keyTable]);
                                        
                                        if (angular.isUndefined($scope.additionals['total_client_discount'][keyTable])) {
                                                $scope.additionals['total_client_discount'][keyTable] = 0;
                                        }
                                        if (angular.isUndefined($scope.additionals['total_loyalty_point_discount'][keyTable])) {
                                                $scope.additionals['total_loyalty_point_discount'][keyTable] = 0;
                                        }
                                       if (angular.isUndefined($scope.modelDataOrder[keyTable].order_discount) || $scope.modelDataOrder[keyTable].order_discount =='') {
                                                $scope.modelDataOrder[keyTable].order_discount = 0;
                                        }
                                      
                                        payment_total = $scope.formatDecimal(payment_total - part * (parseFloat($scope.additionals['total_client_discount'][keyTable]) + parseFloat($scope.additionals['total_loyalty_point_discount'][keyTable]) + parseFloat($scope.modelDataOrder[keyTable].order_discount)) / 100);

                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_total'] = payment_total;
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_cash'] = payment_total;
                                        $scope.modelDataOrder[keyTable]['payments'][noGroup]['payment_card'] = 0;
                                        noGroup++;
                                });
                        }
                }
                /* end update payments */
        }

        $scope.additionals['getFoodCategories'] = function(keyTable) {
                if (angular.isUndefined($scope.additionals['controlCategories'])) {
                        $scope.additionals['controlCategories'] = [];
                }
                if (angular.isUndefined($scope.additionals['controlProducts'])) {
                        $scope.additionals['controlProducts'] = [];
                }
                $scope.additionals['controlCategories'][keyTable] = true;
                $scope.additionals['controlProducts'][keyTable] = false;
                $scope.additionals['controlSupplements'][keyTable] = false;
                if (angular.isUndefined($scope.additionals['food_categories'])) {
                        Crud.get($scope.pathOrder + '/getFoodCategories')
                                .success(function(data) {
                                        $scope.additionals['food_categories'] = data.foodCategories;
                                });
                }
                $scope.additionals['controlMentionProduct'] = [];
                $scope.additionals['controlMentionProductSec'] = [];
                $scope.additionals['controlClientProduct'] = [];

        }

        
        $scope.additionals['closeSupplements'] = function(keyTable) {
                if (angular.isUndefined($scope.modelDataOrder[keyTable].product_errors) || $scope.modelDataOrder[keyTable].product_errors == '') {
                        $scope.additionals['controlSupplements'][keyTable] = false;
                        $scope.additionals['controlProducts'][keyTable] = true;
                }
        }

        $scope.additionals['getFoodProducts'] = function(categoryId, keyTable) {

                if (angular.isUndefined($scope.additionals['selectedCategory'])) {
                        $scope.additionals['selectedCategory'] = [];
                 }
                $scope.additionals['selectedCategory'][keyTable] = {};
                $scope.additionals['selectedCategory'][keyTable][categoryId] = 'selected-table-category';

                if (angular.isUndefined($scope.modelDataOrder[keyTable])){
                        $scope.modelDataOrder[keyTable] = {};
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable].product_errors) || $scope.modelDataOrder[keyTable].product_errors == '') {
                        $scope.additionals['controlSupplements'][keyTable] = false;
                        $scope.additionals['controlProducts'][keyTable] = true;
                }
                $scope.additionals['updateTotalPrice'](keyTable);

                Crud.get($scope.pathOrder + '/getFoodProducts/' + categoryId)
                        .success(function(data) {
                                if (angular.isUndefined($scope.additionals['food_products'])) {
                                        $scope.additionals['food_products'] = [];
                                }
                                if (angular.isUndefined($scope.additionals['supplements'])) {
                                        $scope.additionals['supplements'] = [];
                                }
                                if (angular.isUndefined($scope.additionals['selectedProductClass'])) {
                                        $scope.additionals['selectedProductClass'] = [];
                                }
                                if (angular.isUndefined($scope.additionals['controlMentionProduct'])) {
                                        $scope.additionals['controlMentionProduct'] = [];
                                }
                                if (angular.isUndefined($scope.additionals['controlMentionProductSec'])) {
                                        $scope.additionals['controlMentionProductSec'] = [];
                                }
                                if (angular.isUndefined($scope.additionals['controlClientProduct'])) {
                                        $scope.additionals['controlClientProduct'] = [];
                                }

                                $scope.additionals['food_products'][keyTable] = data.foodProducts;

                                if ($scope.modelDataOrder[keyTable].product_errors == '') {
                                        $scope.additionals['supplements'][keyTable] = [];

                                        if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                                                $scope.additionals['selectedProduct'] = [];
                                        }
                                        $scope.additionals['selectedProduct'][keyTable] = {};
                                        $scope.additionals['selectedProduct'][keyTable].food_product_quantity = 0;
                                        $scope.additionals['selectedProductClass'][keyTable] = [];
                                        $scope.additionals['controlMentionProduct'][keyTable] = [];
                                        $scope.additionals['controlMentionProductSec'][keyTable] = [];
                                        $scope.additionals['controlClientProduct'][keyTable] = [];
                                }
                        });
        }

        $scope.additionals['checkErrorsSupplement'] = function(productIndex, keyTable) {

                if (angular.isUndefined($scope.modelDataOrder[keyTable].product_errors)) {
                        $scope.modelDataOrder[keyTable].product_errors = '';
                }
                var sups = [];
                var cats = [];
                var cat_no = 0;
                var sup_no = 0;

                angular.forEach($scope.additionals['supplements'][keyTable], function(item, key) {
                        angular.forEach(item.supplets, function(items, keys) {
                                //if (items['supplement_type_price'] == 0 && items['supplement_option'] == 0 && items['supplement_price'] == 0) {
                                if (items['supplement_option'] == 0 && items['supplement_display_menu'] == 1) {
                                        cats[cat_no] = items['food_category_id'];
                                        cat_no++;
                                }
                        });
                });

                if (angular.isUndefined($scope.modelDataOrder[keyTable].food_products)) {
                        $scope.modelDataOrder[keyTable].food_products = [];
                }
                cats = cats.filter(function(e, i, arr) {
                        return arr.lastIndexOf(e) === i;
                });

                if ($scope.modelDataOrder[keyTable].food_products.length > 0) {
                        if ($scope.actionSup == 'edit') {
                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex])) {
                                        if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex]['supplements'])) {
                                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex]['supplements']['single'])) {
                                                        sups = $scope.modelDataOrder[keyTable].food_products[productIndex]['supplements']['single'];
                                                }
                                        }
                                        if (cats.length != sups.length) {
                                                sups = [];
                                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex]['food_supplements'])) {
                                                        angular.forEach($scope.modelDataOrder[keyTable].food_products[productIndex]['food_supplements'], function(itemSup, keysSup) {
                                                                //if (itemSup['supplement_type_price'] == 0 && itemSup['supplement_option'] == 0 && itemSup['supplement_price'] == 0) {
                                                                if (itemSup['supplement_option'] == 0 && itemSup['supplement_display_menu'] == 1) {
                                                                        if (!angular.isUndefined(itemSup['food_category_id'])) {
                                                                                sups[sup_no] = itemSup['food_category_id'];
                                                                                sup_no++;
                                                                        }
                                                                }
                                                        });
                                                }
                                        }
                                }
                        } else {
                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[$scope.modelDataOrder[keyTable].food_products.length - 1]['food_supplements'])) {
                                        angular.forEach($scope.modelDataOrder[keyTable].food_products[$scope.modelDataOrder[keyTable].food_products.length - 1]['food_supplements'], function(itemSup, keysSup) {
                                                //if (itemSup['supplement_type_price'] == 0 && itemSup['supplement_option'] == 0 && itemSup['supplement_price'] == 0) {
                                                if (itemSup['supplement_option'] == 0 && itemSup['supplement_display_menu'] == 1) {
                                                        if (!angular.isUndefined(itemSup['food_category_id'])) {
                                                                sups[sup_no] = itemSup['food_category_id'];
                                                                sup_no++;
                                                        }
                                                }
                                        });
                                }
                        }
                } else {
                        if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[0])) {
                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[0]['food_supplements'])) {
                                        angular.forEach($scope.modelDataOrder[keyTable].food_products[0]['food_supplements'], function(itemSup, keysSup) {
                                                //if (itemSup['supplement_type_price'] == 0 && itemSup['supplement_option'] == 0 && itemSup['supplement_price'] == 0) {
                                                if (itemSup['supplement_option'] == 0 && itemSup['supplement_display_menu'] == 1) {
                                                        if (!angular.isUndefined(itemSup['food_category_id'])) {
                                                                sups[sup_no] = itemSup['food_category_id'];
                                                                sup_no++;
                                                        }
                                                }
                                        });
                                }
                        }

                }

                if (cats.length != sups.length) {
                        if (cats.length <= 0) {
                                $scope.modelDataOrder[keyTable].product_errors = '';
                        } else {
                                $scope.modelDataOrder[keyTable].product_errors = 'Trebuie sa selectezi suplimente';
                        }
                } else {
                        $scope.modelDataOrder[keyTable].product_errors = '';
                }
        }

        $scope.additionals['buttonDisabledProduct'] = [];
        $scope.additionals['selectFoodProduct']  = function(keyTable, valueFoodProduct, keyFoodProduct) {
                 if (angular.isUndefined($scope.additionals['selectedFoodProduct'] )) {
                        $scope.additionals['selectedFoodProduct'] = [];
                 }
                 if (angular.isUndefined($scope.additionals['selectedFoodProductClass'] )) {
                        $scope.additionals['selectedFoodProductClass'] = [];
                 }
                 $scope.additionals['selectedFoodProductClass'][keyTable] = [];
                $scope.additionals['selectedFoodProduct'][keyTable] = keyFoodProduct;
                $scope.additionals['selectedFoodProductClass'][keyTable][keyFoodProduct] = 'selected-product';

        }
        
        $scope.additionals['selectSeats']  = function(keyTable, valueSeats, keySeats) {
                 if (angular.isUndefined($scope.additionals['selectedSeats'] )) {
                        $scope.additionals['selectedSeats'] = [];
                 }
                 if (angular.isUndefined($scope.additionals['selectedSeatsClass'] )) {
                        $scope.additionals['selectedSeatsClass'] = [];
                 }
                 $scope.additionals['selectedSeatsClass'][keyTable] = [];

                if (angular.isUndefined($scope.additionals['selectedSeatsModel'] )) {
                        $scope.additionals['selectedSeatsModel'] = [];
                 }
                 $scope.additionals['selectedSeatsModel'][keyTable] = [];
                 
                $scope.additionals['selectedSeats'][keyTable] = keySeats;
                $scope.additionals['selectedSeatsClass'][keyTable][keySeats] = 'selected-seat';
                $scope.additionals['selectedSeatsModel'][keyTable][keySeats] = true;
                
                if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                        $scope.additionals['selectedProduct'] = [];
                }
                if (angular.isUndefined($scope.additionals['selectedProductClass'])) {
                        $scope.additionals['selectedProductClass'] = [];
                }
                $scope.additionals['selectedProduct'][keyTable] = {};
                $scope.additionals['selectedProduct'][keyTable].food_product_quantity = 0;
                $scope.additionals['selectedProductClass'][keyTable] = [];
        }
        
         $scope.additionals['togglePayment'] = function(keyTable) {
                if (angular.isUndefined($scope.additionals['controlPayment'])) {
                        $scope.additionals['controlPayment'] = [];
                }
                $scope.additionals['controlPayment'][keyTable] = !$scope.additionals['controlPayment'][keyTable];
        }
        
        $scope.additionals['toggleDiscountOrder'] = function(keyTable) {
                if (angular.isUndefined($scope.additionals['controlDiscountOrder'])) {
                        $scope.additionals['controlDiscountOrder'] = [];
                }
                $scope.additionals['controlDiscountOrder'][keyTable] = !$scope.additionals['controlDiscountOrder'][keyTable];
        }
                
        $scope.additionals['getSupplements'] = function(product, productIndex, keyTable) {
                
                $scope.additionals['buttonDisabledProduct'][product.food_product_id] = true;
                $scope.maxCategory = '';
                $scope.maxNumber = '';
                if (product.max_free != null) {
                        var maxArray = product.max_free.split(':');
                        $scope.maxCategory = maxArray[0];
                        $scope.maxNumber = maxArray[1];
                }

                //$scope.additionals['checkErrorsSupplement'](productIndex);

                if (angular.isUndefined($scope.modelDataOrder)) {
                        $scope.modelDataOrder = [];
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                        $scope.modelDataOrder[keyTable] = {};
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable].product_errors)) {
                        $scope.modelDataOrder[keyTable].product_errors = '';
                }

                if ($scope.modelDataOrder[keyTable].product_errors == '' || $scope.actionSup == 'edit') {
                        
                        if ($scope.actionSup == 'edit') {
                                $scope.actionSup = '';
                        }
                        if (angular.isUndefined($scope.additionals['multi'])) {
                                $scope.additionals['multi'] = [];
                        }
                        $scope.additionals['multi'][keyTable] = 0;
                        if (angular.isUndefined($scope.modelDataOrder[keyTable].food_products)) {
                                $scope.modelDataOrder[keyTable].food_products = [];
                        } else {
                                 if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                                        $scope.additionals['selectedProduct'] = [];
                                 }
                                        
                                $scope.additionals['selectedProduct'][keyTable] = $scope.additionals['food_products'][keyTable][productIndex];
                                $scope.additionals['selectedProduct'][keyTable].food_product_quantity = 1;

                                $scope.additionals['selectedProductClass'][keyTable] = [];
                                $scope.additionals['selectedProductClass'][keyTable][productIndex] = 'selected-product';
                        }

                        if (angular.isUndefined(product['food_product_discount_type'])) {
                                product['food_product_discount_type'] = 0;
                        }
                        if (angular.isUndefined(product['food_product_discount_value'])) {
                                product['food_product_discount_value'] = 0;
                        }
                        var food_product_client_seat = '';
                        if (angular.isUndefined($scope.additionals['selectedSeats'])) {
                               $scope.additionals['selectedSeats'] = []; 
                        }

                        $scope.errors.generic = [];
                        
                         if ((!angular.isUndefined($scope.additionals['selectedSeats'] [keyTable]) && $scope.additionals['selectedSeats'] [keyTable] !== '') || $scope.tables == 0) {

                                 if (!angular.isUndefined($scope.additionals['rangeSeats'] [keyTable]) && !angular.isUndefined($scope.additionals['rangeSeats'] [keyTable][$scope.additionals['selectedSeats'] [keyTable]])) {
                                         food_product_client_seat = $scope.additionals['rangeSeats'] [keyTable][$scope.additionals['selectedSeats'] [keyTable]];
                                }
                                                        
                                $scope.modelDataOrder[keyTable].food_products.push({
                                        'food_product_id': product['food_product_id'],
                                        'food_product_code': product['food_product_code'],
                                        'food_product_name': product['food_product_name'],
                                        'food_product_price': product['food_product_price'],
                                        'food_product_packaging': product['food_product_packaging'],
                                        'food_product_discount_type': product['food_product_discount_type'],
                                        'food_product_discount_value': product['food_product_discount_value'],
                                        'food_product_quantity': 1,
                                        'food_product_client': product['food_product_client'],
                                        'food_product_client_seat': food_product_client_seat
                                });
                        } else {
                                $scope.errors.generic = ['Selectati mai intai un loc ...'];
                        }
                       if (angular.isUndefined($scope.additionals['indexProduct'])) {
                                $scope.additionals['indexProduct'] = [];
                        }
                        $scope.additionals['indexProduct'][keyTable] = $scope.modelDataOrder[keyTable].food_products.length - 1;

                        if (!angular.isUndefined($scope.modelDataOrder[keyTable].order_source)) {
                                var pathSup = $scope.pathOrder + '/getSupplements/?productId=' + product['food_product_id'] + '&orderSource=' + $scope.modelDataOrder[keyTable].order_source;
                        } else {
                                var pathSup = $scope.pathOrder + '/getSupplements/?productId=' + product['food_product_id'];
                        }
                        Crud.get(pathSup)
                                .success(function(data) {
                                        if (data.supplements.length > 0) {
                                                $scope.additionals['controlSupplements'][keyTable] = true;
                                        }
                                        if (angular.isUndefined($scope.additionals.indexSupplement)) {
                                                $scope.additionals.indexSupplement = [];
                                        }
                                        $scope.additionals.indexSupplement[keyTable] = 0;
                                        $scope.additionals['supplements'][keyTable] = data.supplements;
                                        $scope.additionals['checkErrorsSupplement'](productIndex, keyTable);
                                        
                                        if(data.supplements.length > 0 ){
                                                $scope.additionals['controlProducts'][keyTable] = false;
                                        }

                                        $timeout(function() {
                                                $scope.additionals['buttonDisabledProduct'][product.food_product_id] = false;
                                        }, 500);

                                });

                        $scope.additionals['updateTotalPrice'](keyTable);

                }
        }

        $scope.additionals['addSupplement'] = function(supplement, supplementValue, productIndex, categoryId, supplementType, keyTable) {

                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex])) {
                        if (angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements)) {
                                $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements = [];
                        }
                }
                if (angular.isUndefined($scope.additionals['sing'])) {
                        $scope.additionals['sing'] = [];
                }
                $scope.additionals['sing'][keyTable] = {};

                if ($scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length > 0) {
                        angular.forEach($scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements, function(itemSup, keySup) {
                                if (angular.isUndefined(itemSup['extra']) || itemSup['extra'] == 0) {
                                        angular.forEach($scope.additionals['supplements'][keyTable], function(item, key) {
                                                if (angular.isUndefined(item['extra']) || item['extra'] == 0) {
                                                        angular.forEach(item.supplets, function(items, keys) {
                                                                if (items.supplement_option == 0 && items.supplement_id == itemSup.supplement_id) {
                                                                        $scope.additionals['sing'][keyTable][key] = keySup;
                                                                }
                                                        });
                                                }
                                        });
                                }
                        });
                }

                if (!angular.isUndefined(supplementType)) {

                        if (supplementType == 'multiple') {
                                if (supplementValue == true) {

                                        if (categoryId == $scope.maxCategory) {
                                                var number = 0;
                                                angular.forEach($scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements, function(item, key) {
                                                        if (item.food_category_id == $scope.maxCategory) {
                                                                number++;
                                                        }
                                                        if (number >= $scope.maxNumber) {
                                                                supplement.supplement_max_free = 0;
                                                        } else {

                                                        }
                                                })

                                                if (number < $scope.maxNumber) {
                                                        $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.push(supplement);
                                                        // supplement.supplement_price = 0;
                                                        //supplement.supplement_max_free = 1;
                                                        $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements[$scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length - 1].supplement_max_free = 1;
                                                        //$scope.additionals['updateTotalPrice'](keyTable);
                                                        $scope.additionals['multi'][keyTable] = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length;
                                                } else {
                                                        $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.push(supplement);
                                                        $scope.additionals['updateTotalPrice'](keyTable);
                                                        $scope.additionals['multi'][keyTable] = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length;
                                                }

                                        } else {
                                                $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.push(supplement);
                                                $scope.additionals['updateTotalPrice'](keyTable);
                                                $scope.additionals['multi'] = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length;
                                        }
                                } else {
                                        var pos = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.map(function(e) {
                                                return e['supplement_id'];
                                        }).indexOf(supplement['supplement_id']);
                                        $scope.additionals['removeSupplement'](supplement.supplement_price, productIndex, pos, supplement.supplement_id, keyTable);
                                }
                        }
                        if (supplementType == 'extra') {
                                if (supplementValue == true) {
                                        supplement['extra'] = 1;
                                        $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.push(supplement);
                                        $scope.additionals['updateTotalPrice'](keyTable);
                                        $scope.additionals['extra'][keyTable] = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length;
                                } else {
                                        var pos = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.map(function(e) {
                                                return e['supplement_id'];
                                        }).indexOf(supplement['supplement_id']);
                                        $scope.additionals['removeSupplement'](supplement.supplement_price, productIndex, pos, supplement.supplement_id, keyTable);
                                }
                        }
                        if (supplementType == 'single') {
                                $scope.additionals['nextSupplement']($scope.additionals.indexSupplement[keyTable], keyTable);

                                if (angular.isUndefined($scope.additionals['sing'][keyTable])) {
                                        $scope.additionals[keyTable]['sing'][keyTable] = {};
                                }
                                angular.forEach($scope.additionals['supplements'][keyTable], function(item, key) {
                                        if (angular.isUndefined(item['extra']) || item['extra'] == 0) {
                                                angular.forEach(item.supplets, function(items, keys) {
                                                        if (items.supplement_id == supplementValue) {
                                                                if (angular.isUndefined($scope.additionals['sing'][keyTable][key])) {
                                                                        $scope.additionals['multi'] = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length;
                                                                        $scope.additionals['sing'][keyTable][key] = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.length;
                                                                }
                                                                $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements[$scope.additionals['sing'][keyTable][key]] = items;
                                                        }
                                                });
                                        }
                                });

                                $scope.additionals['updateTotalPrice'](keyTable);
                        }
                }

                $scope.additionals['checkErrorsSupplement'](productIndex, keyTable);
        }

        $scope.additionals['removeSupplement'] = function(supplementPrice, productIndex, supplementIndex, supplementId, keyTable) {

                var position = $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.map(function(e) {
                        if (e['supplement_option'] == 1) {
                                return e['supplement_id'];
                        }
                }).indexOf(supplementId);
                $scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements.splice(position, 1);

                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex].supplements.single)) {
                        if (!angular.isUndefined($scope.additionals['sing'][keyTable])) {
                                var key = Object.keys($scope.additionals['sing']).filter(function(key) {
                                        //if (e['supplement_option'] == 1) {
                                        return $scope.additionals['sing'][keyTable][key] === supplementIndex;
                                        //}
                                })[0];

                                angular.forEach($scope.additionals['sing'][keyTable], function(itemSing, keySing) {
                                        if (itemSing > supplementIndex) {
                                                $scope.additionals['sing'][keyTable][keySing] = itemSing - 1;
                                                if (itemSing - 1 < 0) {
                                                        delete $scope.additionals['sing'][keyTable][keySing];
                                                }
                                        }
                                        if (itemSing == supplementIndex) {
                                                delete $scope.additionals['sing'][keyTable][keySing];
                                        }
                                });
                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex].supplements.single[key])) {

                                }
                        }
                }

                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex].supplements.multiple)) {
                        delete $scope.modelDataOrder[keyTable].food_products[productIndex].supplements.multiple[supplementId];
                }

                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[productIndex].supplements.extra)) {
                        delete $scope.modelDataOrder[keyTable].food_products[productIndex].supplements.extra[supplementId];
                }

                $scope.additionals['checkErrorsSupplement'](productIndex, keyTable);

                var number = 0;
                angular.forEach($scope.modelDataOrder[keyTable].food_products[productIndex].food_supplements, function(item, key) {
                        if (item.food_category_id == $scope.maxCategory) {
                                number++;
                                if (number <= $scope.maxNumber) {
                                        item.supplement_max_free = 1;
                                } else {
                                        item.supplement_max_free = 0;
                                }
                        }
                })
                $scope.additionals['updateTotalPrice'](keyTable);
        }
        
        $scope.additionals['updateTotalPrice'] = function(keyTable) {

                $scope.additionals['total_product'][keyTable] = 0;
                $scope.additionals['total_product_discount'][keyTable] = 0;

                var total_product_discount = 0;
                var total_supplement_discount = 0;

                if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                        $scope.modelDataOrder[keyTable] = {};
                }

                angular.forEach($scope.modelDataOrder[keyTable]['food_products'], function(itemProduct, keyProduct) {
                        if (!angular.isUndefined(itemProduct['food_product_discount_type'])) {
                                if (itemProduct['food_product_discount_type'] == 0) {
                                        itemProduct['order_food_product_discount_value'] = parseFloat(itemProduct.food_product_price * itemProduct.food_product_discount_value / 100);
                                        total_product_discount = total_product_discount + parseFloat(itemProduct.food_product_price * itemProduct.food_product_discount_value / 100) * itemProduct.food_product_quantity;
                                } else {
                                        total_product_discount = total_product_discount + parseFloat(itemProduct.food_product_discount_value) * itemProduct.food_product_quantity;
                                        itemProduct['order_food_product_discount_value'] = parseFloat(itemProduct.food_product_discount_value);
                                }
                        }

                        $scope.additionals['total_product'][keyTable] = $scope.additionals['total_product'][keyTable] + parseFloat(itemProduct.food_product_price) * itemProduct.food_product_quantity + parseFloat(itemProduct.food_product_packaging) * itemProduct.food_product_quantity;
                        angular.forEach(itemProduct.food_supplements, function(itemSupplement, keySupplement) {
                                if (!angular.isUndefined(itemSupplement.supplement_price)) {
                                        if (angular.isUndefined(itemSupplement.supplement_max_free) || itemSupplement.supplement_max_free == 0) {
                                                if (!angular.isUndefined(itemSupplement['supplement_discount_type']) && itemSupplement['supplement_discount_type'] != null && itemSupplement['supplement_discount_type'] != 'null') {
                                                        if (itemSupplement['supplement_discount_type'] == 0) {
                                                                total_supplement_discount = total_supplement_discount + parseFloat(itemSupplement.supplement_price * itemSupplement.supplement_discount_value / 100) * itemProduct.food_product_quantity;

                                                                itemSupplement['order_supplement_discount_value'] = parseFloat(itemSupplement.supplement_price * itemSupplement.supplement_discount_value / 100);
                                                        } else {
                                                                total_supplement_discount = total_supplement_discount + parseFloat(itemSupplement.supplement_discount_value) * itemProduct.food_product_quantity;
                                                                itemSupplement['order_supplement_discount_value'] = parseFloat(itemSupplement.supplement_discount_value);
                                                        }
                                                }

                                                $scope.additionals['total_product'][keyTable] = $scope.additionals['total_product'][keyTable] + parseFloat(itemSupplement.supplement_price) * itemProduct.food_product_quantity + parseFloat(itemSupplement.supplement_packaging) * itemProduct.food_product_quantity;
                                        }
                                }
                        });

                        if (itemProduct.food_product_quantity != '' && itemProduct.food_product_quantity == 0) {
                                $scope.modelDataOrder[keyTable].food_products.splice(keyProduct, 1);
                                $scope.additionals['updateTotalPrice'](keyTable);
                        }
                });

                $scope.additionals['total_product_discount'][keyTable] = total_product_discount + total_supplement_discount;
                $scope.additionals['total_product'][keyTable] = $scope.additionals['total_product'][keyTable] - $scope.additionals['total_product_discount'][keyTable];

                $scope.additionals['total_product_discount'][keyTable] = parseFloat($scope.additionals['total_product_discount'][keyTable]);
                $scope.additionals['total_product'][keyTable] = parseFloat($scope.additionals['total_product'][keyTable]);

                $scope.modelDataOrder[keyTable]['order_total'] = $scope.additionals['total_product'][keyTable];

                $scope.additionals['applyDiscountCampaign'](keyTable);
                $scope.additionals['changeSelectDiscountEvent']($scope.modelDataOrder[keyTable].discount_id, $scope.modelDataOrder[keyTable].order_amount, $scope.modelDataOrder[keyTable].order_shipping, keyTable);

                $scope.additionals['updatePayments'](keyTable);

        }

        $scope.additionals['changeQuantityJs'] = function(product, keyTable) {
                product['food_product_quantity'] = parseInt(product['food_product_quantity']);
                $scope.additionals['updateTotalPrice'](keyTable);
        }

        $scope.additionals['removeProduct'] = function(productPrice, productQuantity, index, keyTable) {
               $scope.errors.generic = [];
                if (!angular.isUndefined($scope.modelDataOrder[keyTable]) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products[index])) {
                        
                        angular.forEach($scope.modelDataOrder[keyTable].food_products[index].food_supplements, function(item, key) {
                                $scope.additionals['removeSupplement'](item.supplement_price, index, key, item.supplement_id, keyTable);
                        });

                        $scope.modelDataOrder[keyTable].food_products.splice(index, 1);
                        $scope.additionals['updateTotalPrice'](keyTable);
        
                        $scope.additionals['selectedProduct'][keyTable] = $scope.modelDataOrder[keyTable].food_products[$scope.modelDataOrder[keyTable].food_products.length - 1];
                        $scope.additionals['indexProduct'][keyTable] = $scope.additionals['indexProduct'] - 1;
                        if (!angular.isUndefined($scope.additionals['selectedProduct'][keyTable])) {
                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].order_source)) {
                                        var pathSup = $scope.pathOrder + '/getSupplements/?productId=' + $scope.additionals['selectedProduct'][keyTable]['food_product_id'] + '&orderSource=' + $scope.modelDataOrder[keyTable].order_source;
                                } else {
                                        var pathSup = $scope.pathOrder + '/getSupplements/?productId=' + $scope.additionals['selectedProduct'][keyTable]['food_product_id'];
                                }
                                Crud.get(pathSup)
                                        .success(function(data) {
                                                $scope.additionals.indexSupplement[keyTable] = 0;
                                                $scope.additionals['supplements'][keyTable] = data.supplements;
                                        });
                        } else {
                                $scope.errors.generic = ['Introduceti si selectati mai intai un produs ...'];
                        }
        
                        if ($scope.modelDataOrder[keyTable].food_products.length <= 0 || index == $scope.modelDataOrder[keyTable].food_products.length) {
                                $scope.additionals['supplements'][keyTable] = [];
                                $scope.modelDataOrder[keyTable].product_errors = '';
                                $scope.additionals['selectedProduct'][keyTable] = {};
                                $scope.additionals['selectedProductClass'][keyTable] = [];
                        }
        
                        if (!angular.isUndefined($scope.additionals['selectedProductClass'][keyTable])) {
                                $scope.additionals['selectedProductClass'][keyTable][index] = '';
                        }
                                
                } else {
                        $scope.errors.generic = ['Introduceti si selectati mai intai un produs ...'];
                }
                
        }

        $scope.additionals['editProduct'] = function(product, index, on, keyTable) {
                $scope.errors.generic = [];
                if (!angular.isUndefined($scope.modelDataOrder[keyTable]) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products[index])) {
                                                
                        if (!angular.isUndefined(on)) {
                                $scope.additionals['on'][keyTable] = true;
                        }
                        $scope.actionSup = 'edit';
                        if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                                $scope.additionals['selectedProduct'] = [];
                        }
                        if (angular.isUndefined($scope.additionals['indexProduct'])) {
                                $scope.additionals['indexProduct'] = [];
                        }
                        $scope.additionals['selectedProduct'][keyTable] = $scope.modelDataOrder[keyTable].food_products[index];
                        $scope.additionals['indexProduct'][keyTable] = index;


                        if (!angular.isUndefined($scope.additionals['selectedProduct'][keyTable])) {
                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].order_source)) {
                                        var pathSup = $scope.pathOrder + '/getSupplements/?productId=' + $scope.additionals['selectedProduct'][keyTable]['food_product_id'] + '&orderSource=' + $scope.modelDataOrder[keyTable].order_source;
                                } else {
                                        var pathSup = $scope.pathOrder + '/getSupplements/?productId=' + $scope.additionals['selectedProduct'][keyTable]['food_product_id'];
                                }
                                Crud.get(pathSup)
                                        .success(function(data) {
                
                                                if (data.supplements.length > 0) {
                                                        $scope.additionals['controlProducts'][keyTable] = false;
                                                        $scope.additionals['controlSupplements'][keyTable] = true;
                                                }
                                                if (angular.isUndefined($scope.additionals.indexSupplement)) {
                                                        $scope.additionals.indexSupplement = [];
                                                }
                                                if (angular.isUndefined($scope.additionals['supplements'])) {
                                                        $scope.additionals['supplements'] = [];
                                                }
                                                if (angular.isUndefined($scope.additionals['sing'])) {
                                                        $scope.additionals['sing'] = [];
                                                }
                                                $scope.additionals.indexSupplement[keyTable] = 0;
                                                $scope.additionals['supplements'][keyTable] = data.supplements;
                
                                                //if (angular.isUndefined($scope.additionals['sing'])) {
                                                $scope.additionals['sing'][keyTable] = {};
                                                //}
                                                if (!angular.isUndefined($scope.modelDataOrder[keyTable].food_products[index].food_supplements)) {
                                                        if ($scope.modelDataOrder[keyTable].food_products[index].food_supplements.length > 0) {
                                                                angular.forEach($scope.modelDataOrder[keyTable].food_products[index].food_supplements, function(itemSup, keySup) {
                                                                        if (angular.isUndefined(itemSup['extra']) || itemSup['extra'] == 0) {
                                                                                angular.forEach($scope.additionals['supplements'][keyTable], function(item, key) {
                                                                                        if (angular.isUndefined(item['extra']) || item['extra'] == 0) {
                                                                                                angular.forEach(item.supplets, function(items, keys) {
                                                                                                        if (items.supplement_option == 0 && items.supplement_id == itemSup.supplement_id) {
                                                                                                                if (angular.isUndefined($scope.additionals['sing'][keyTable][key])) {
                                                                                                                        $scope.additionals['sing'][keyTable][key] = keySup;
                                                                                                                }
                                                                                                                $scope.modelDataOrder[keyTable].food_products[index]['supplements']['single'][key] = itemSup.supplement_id;
                                                                                                        }
                                                                                                });
                                                                                        }
                                                                                })
                                                                        }
                                                                });
                                                        }
                                                }
                                        });
                
                                $scope.additionals['selectedProductClass'] = [];
                                if (angular.isUndefined($scope.additionals['food_products'])) {
                                        $scope.additionals['food_products'] = [];
                                }
                                if (!angular.isUndefined($scope.additionals['food_products'][keyTable])) {
                                        var productIndex = $scope.additionals['food_products'][keyTable].map(function(e) {
                                                return e['food_product_id'];
                                        }).indexOf($scope.additionals['selectedProduct'][keyTable]['food_product_id']);
                                        if (angular.isUndefined($scope.additionals['selectedProductClass'][keyTable])) {
                                                $scope.additionals['selectedProductClass'][keyTable] = [];
                                        }
                                        $scope.additionals['selectedProductClass'][keyTable][productIndex] = 'selected-product';
                                }
                        
                        } else {
                                 $scope.errors.generic = ['Introduceti si selectati mai intai un produs ...'];
                        }
                } else {
                        $scope.errors.generic = ['Introduceti si selectati mai intai un produs ...'];
                }
        }

        $scope.additionals['applyDiscountCampaign'] = function(keyTable) {

                if (!angular.isUndefined($scope.additionals['discount_campaigns'][keyTable])) {
                        var total_client_discount = 0;
                        angular.forEach($scope.additionals['discount_campaigns'][keyTable], function(item, index) {
                                if (item.discount_campaign_value_type == 0) {//procent
                                        total_client_discount += parseFloat(parseFloat($scope.additionals['total_product'][keyTable]) * parseFloat(item.discount_campaign_value) / 100);
                                }
                                if (item.discount_campaign_value_type == 1) {//fixed value
                                        total_client_discount += parseFloat(item.discount_campaign_value);
                                }
                        });
                        $scope.additionals['total_client_discount'][keyTable] = parseFloat(total_client_discount);
                }
                if ($scope.modelDataOrder[keyTable].order_loyalty_point_discount > 0) {
                        $scope.additionals['total_loyalty_point_discount'][keyTable] = parseFloat($scope.modelDataOrder[keyTable].order_loyalty_point_discount);
                }
                if ($scope.modelDataOrder[keyTable]['order_total'] >= 0) {
                        $scope.modelDataOrder[keyTable]['order_total'] = $scope.modelDataOrder[keyTable]['order_total'] - $scope.additionals['total_client_discount'] - $scope.additionals['total_loyalty_point_discount'];
                }
        }

        $scope.additionals['calcLoyaltyPointDiscount'] = function(model, keyTable) {
                if ($scope.additionals['loyalty_point_accumulated'][keyTable] >= $scope.additionals['settings']['min_no_loyalty_points']) {
                        model.order_loyalty_point_discount = $scope.formatDecimal(parseFloat($scope.additionals['settings']['value_granted_loyalty_points']) * parseFloat(model['loyalty_point_selected']));

                        $scope.additionals['total_loyalty_point_discount'][keyTable] = model.order_loyalty_point_discount;
                        $scope.modelDataOrder[keyTable]['order_total'] = parseFloat($scope.additionals['total_product']) - parseFloat($scope.additionals['total_client_discount'][keyTable]) - parseFloat($scope.additionals['total_loyalty_point_discount'][keyTable]);
                        
                        $scope.additionals['updatePayments'](keyTable);
                }
        }

        $scope.additionals['changeSelectDiscountEvent'] = function(discountId, orderAmount, orderShipping, keyTable) {
                $scope.additionals['changeSelectDiscount'](discountId, orderAmount, orderShipping, keyTable);
        }
        $scope.additionals['changeSelectDiscount'] = function(discountId, orderAmount, orderShipping, keyTable) {
                /*if (angular.isUndefined($scope.modelDataOrder)) {
                 $scope.modelDataOrder = [];
                 } 
                 if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                 $scope.modelDataOrder[keyTable] = {};
                 }  */
                 
                 $scope.modelDataOrder[keyTable]['discount_value'] = 0;
                 $scope.modelDataOrder[keyTable]['order_discount'] = 0;
                $scope.modelDataOrder[keyTable]['order_total'] = parseFloat($scope.additionals['total_product'][keyTable]) - parseFloat($scope.additionals['total_client_discount'][keyTable]) - parseFloat($scope.additionals['total_loyalty_point_discount'][keyTable]);

                var position = $scope.additionals['discounts'].map(function(e) {
                        return e['id'];
                }).indexOf(discountId);
                if (position >= 0) {

                        $scope.modelDataOrder[keyTable].discount_type_id = $scope.additionals['discounts'][position]['discount_type_id'];

                        if ($scope.modelDataOrder[keyTable].discount_type_id != 2) {
                                $scope.modelDataOrder[keyTable].discount_value = $scope.additionals['discounts'][position]['discount_value'];
                        }

                        if ($scope.modelDataOrder[keyTable].discount_type_id == 1) {
                                $scope.modelDataOrder[keyTable].order_discount = $scope.additionals['discounts'][position]['discount_value'];
                        }
                        if ($scope.modelDataOrder[keyTable].discount_type_id == 0) {
                                if ($scope.modelDataOrder[keyTable]['order_total'] > 0) {
                                        $scope.modelDataOrder[keyTable].order_discount = $scope.formatDecimal($scope.modelDataOrder[keyTable]['order_total'] * $scope.modelDataOrder[keyTable].discount_value / 100);
                                } else {
                                        $scope.modelDataOrder[keyTable].order_discount = 0;
                                }
                        }
                        if ($scope.modelDataOrder[keyTable].discount_type_id == 2) {
                                $scope.modelDataOrder[keyTable].order_discount = $scope.modelDataOrder[keyTable].discount_value;
                        }

                        $scope.modelDataOrder[keyTable]['order_total'] = parseFloat($scope.modelDataOrder[keyTable]['order_total']) - parseFloat($scope.modelDataOrder[keyTable].order_discount);

                } else {
                        $scope.modelDataOrder[keyTable].discount_type_id = '';
                        $scope.modelDataOrder[keyTable].discount_value = '';
                        $scope.modelDataOrder[keyTable].order_discount = '';
                }
                
                 $scope.additionals['updatePayments'](keyTable);

        }

        $scope.additionals['changeInputDiscount'] = function(discountValue, orderAmount, orderShipping, keyTable) {
                $scope.modelDataOrder[keyTable]['order_total'] = $scope.additionals['total_product'][keyTable] - $scope.additionals['total_client_discount'][keyTable] - $scope.additionals['total_loyalty_point_discount'][keyTable];

                if ($scope.modelDataOrder[keyTable].discount_type_id == 2) {
                        $scope.modelDataOrder[keyTable].order_discount = discountValue;
                        $scope.modelDataOrder[keyTable]['order_total'] = $scope.modelDataOrder[keyTable]['order_total'] - $scope.modelDataOrder[keyTable].order_discount;
                }
                
                $scope.additionals['updatePayments'](keyTable);
        }

        $scope.additionals['controlMentionProductSec'] = [];
        $scope.additionals['mentionProduct'] = function(ev, index, keyCode, keyTable) {
                if (angular.isUndefined($scope.additionals['controlMentionProduct'][keyTable])) {
                        $scope.additionals['controlMentionProduct'][keyTable] = [];
                }
                angular.forEach($scope.modelDataOrder[keyTable].food_products, function(item, key) {
                        if (key == index) {
                                if ($scope.additionals['controlMentionProduct'][keyTable][index] == true) {
                                        if (!angular.isUndefined(keyCode) && keyCode != null) {
                                                if (ev.keyCode === 27) {
                                                        $scope.additionals['controlMentionProduct'][keyTable][index] = false;
                                                }
                                        } else {
                                                $scope.additionals['controlMentionProduct'][keyTable][index] = false;
                                        }
                                } else {
                                        $scope.additionals['controlMentionProduct'][keyTable][index] = true;
                                }
                        } else {
                                $scope.additionals['controlMentionProduct'][keyTable][key] = false;
                        }
                })
        }
        
        $scope.additionals['mentionProductSec'] = function(ev, index, keyCode, keyTable) {
                $scope.errors.generic = [];
                 if (!angular.isUndefined($scope.modelDataOrder[keyTable]) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products[index])) {
                        
                        if (angular.isUndefined($scope.additionals['controlMentionProductSec'][keyTable])) {
                                $scope.additionals['controlMentionProductSec'][keyTable] = [];
                        }
                        angular.forEach($scope.modelDataOrder[keyTable].food_products, function(item, key) {
                                if (key == index) {
                                        if ($scope.additionals['controlMentionProductSec'][keyTable][index] == true) {
                                                if (!angular.isUndefined(keyCode) && keyCode != null) {
                                                        if (ev.keyCode === 27) {
                                                                $scope.additionals['controlMentionProductSec'][keyTable][index] = false;
                                                        }
                                                } else {
                                                        $scope.additionals['controlMentionProductSec'][keyTable][index] = false;
                                                }
                                        } else {
                                                $scope.additionals['controlMentionProductSec'][keyTable][index] = true;
                                        }
                                } else {
                                        $scope.additionals['controlMentionProductSec'][keyTable][key] = false;
                                }
                        })
                } else {
                        $scope.errors.generic = ['Introduceti si selectati mai intai un produs ...'];
                }
        }

        $scope.additionals['controlClientProductSec'] = [];
        $scope.additionals['controlClientProduct'] = [];
        $scope.additionals['clientProduct'] = function(ev, index, keyCode, keyTable) {
                if (angular.isUndefined($scope.additionals['controlClientProduct'][keyTable])) {
                        $scope.additionals['controlClientProduct'][keyTable] = [];
                }
                angular.forEach($scope.modelDataOrder[keyTable].food_products, function(item, key) {
                        if (key == index) {
                                if ($scope.additionals['controlClientProduct'][keyTable][index] == true) {
                                        if (!angular.isUndefined(keyCode) && keyCode != null) {
                                                if (ev.keyCode === 27) {
                                                        $scope.additionals['controlClientProduct'][keyTable][index] = false;
                                                }
                                        } else {
                                                $scope.additionals['controlClientProduct'][keyTable][index] = false;
                                        }
                                } else {
                                        $scope.additionals['controlClientProduct'][keyTable][index] = true;
                                }
                        } else {
                                $scope.additionals['controlClientProduct'][keyTable][key] = false;
                        }
                })
                
        }
        $scope.additionals['clientProductSec'] = function(ev, index, keyCode, keyTable) {
                $scope.errors.generic = [];
                 if (!angular.isUndefined($scope.modelDataOrder[keyTable]) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products) && !angular.isUndefined($scope.modelDataOrder[keyTable].food_products[index])) {
                        
                        if (angular.isUndefined($scope.additionals['controlClientProductSec'][keyTable])) {
                                $scope.additionals['controlClientProductSec'][keyTable] = [];
                        }
                        angular.forEach($scope.modelDataOrder[keyTable].food_products, function(item, key) {
                                if (key == index) {
                                        if ($scope.additionals['controlClientProductSec'][keyTable][index] == true) {
                                                if (!angular.isUndefined(keyCode) && keyCode != null) {
                                                        if (ev.keyCode === 27) {
                                                                $scope.additionals['controlClientProductSec'][keyTable][index] = false;
                                                        }
                                                } else {
                                                        $scope.additionals['controlClientProductSec'][keyTable][index] = false;
                                                }
                                        } else {
                                                $scope.additionals['controlClientProductSec'][keyTable][index] = true;
                                        }
                                } else {
                                        $scope.additionals['controlClientProductSec'][keyTable][key] = false;
                                }
                        })
                        
                } else {
                         $scope.errors.generic = ['Introduceti si selectati mai intai un produs ...'];
                }
        }

        $scope.additionals['closeFieldOrder'] = function(paramName, paramId, model, keyAddress, key) {
                if (!angular.isUndefined(key)) {
                        model[key][paramName] = '';
                        if (!angular.isUndefined(paramId)) {
                                model[key][paramId] = '';
                        }
                } else {

                        model[paramName] = '';
                        if (!angular.isUndefined(paramId)) {
                                model[paramId] = '';
                        }
                        if (paramName == 'order_phone') {
                                $scope.modelDataOrder[keyTable]['order_total'] = 0;
                                if (angular.isUndefined($scope.additionals['discount_campaigns'])) {
                                        $scope.additionals['discount_campaigns'] = [];
                                }
                                $scope.additionals['discount_campaigns'][keyTable] = [];

                        }

                }
        }

        $scope.additionals['nextSupplement'] = function(indexSupplement, keyTable) {
                if (angular.isUndefined($scope.additionals['supplements'])) {
                        $scope.additionals['supplements'] = [];
                }
                if (angular.isUndefined($scope.additionals['supplements'][keyTable])) {
                        $scope.additionals['supplements'][keyTable] = [];
                }
                if (angular.isUndefined($scope.additionals.indexSupplement)) {
                        $scope.additionals.indexSupplement = [];
                }
                if (indexSupplement < $scope.additionals['supplements'][keyTable].length - 1) {
                        $scope.additionals.indexSupplement[keyTable] = indexSupplement + 1;
                }
        }
        $scope.additionals['previousSupplement'] = function(indexSupplement, keyTable) {
                if (angular.isUndefined($scope.additionals['supplements'])) {
                        $scope.additionals['supplements'] = [];
                }
                if (angular.isUndefined($scope.additionals['supplements'][keyTable])) {
                        $scope.additionals['supplements'][keyTable] = [];
                }
                if (angular.isUndefined($scope.additionals.indexSupplement)) {
                        $scope.additionals.indexSupplement = [];
                }
                if (indexSupplement > 0) {
                        $scope.additionals.indexSupplement[keyTable] = indexSupplement - 1;
                }
        }

        $scope.submitOrder = function(keyTable) {
                if (angular.isUndefined($scope.modelDataOrder)) {
                        $scope.modelDataOrder = [];
                }
                if (angular.isUndefined($scope.modelDataOrder[keyTable])) {
                        $scope.modelDataOrder[keyTable] = {};
                }
                $scope.modelDataOrder[keyTable].final = 1;
        }

        $scope.additionals['internFunctionOrder'] = function(ev, model, keyTable) {
                if (model['client_phone'] != '') {
                        var checkClient = $scope.additionals['checkField']($scope.additionals['clients'], 'id', 'client_phone', model['order_phone']);
                        if (checkClient) {
                                $scope.modelDataOrder[keyTable].client_id = checkClient;
                        } else {
                                $scope.modelDataOrder[keyTable].client_id = 0;
                        }
                }
                $scope.modelDataOrder[keyTable].shipping_method_id = 3;
                $scope.modelDataOrder[keyTable].payment_method_id = 1;
                //model.client_id = 3;

        }

        $scope.additionals['functionResultOrder'] = function(ev, data, keyTable) {

                 if (angular.isUndefined( $scope.additionals['selectedSeatsClass'])) {
                        $scope.additionals['selectedSeatsClass'] = [];
                }
                 $scope.additionals['selectedSeatsClass'][keyTable] = '';
                if (angular.isUndefined( $scope.additionals['selectedSeats'])) {
                        $scope.additionals['selectedSeats'] = [];
                }
                 $scope.additionals['selectedSeats'][keyTable] = '';
                if (angular.isUndefined( $scope.additionals['selectedSeatsModel'])) {
                        $scope.additionals['selectedSeatsModel'] = [];
                }
                $scope.additionals['selectedSeatsModel'][keyTable] = false;
                
                if (angular.isUndefined($scope.modelDataOrder[keyTable].product_errors) || $scope.modelDataOrder[keyTable].product_errors == '') {

                        $scope.additionals['controlSupplements'][keyTable] = false;
                        $scope.additionals['controlMentionProduct'] = [];
                        $scope.additionals['controlClientProduct'] = [];
                }
                if (angular.isUndefined($scope.additionals['supplements'])) {
                        $scope.additionals['supplements'] = [];
                }
                $scope.additionals['supplements'][keyTable] = [];
                if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                        $scope.additionals['selectedProduct'] = [];
                }
                $scope.additionals['selectedProduct'][keyTable] = {};

                $scope.additionals['selectedProduct'][keyTable].food_product_quantity = 0;

                if (angular.isUndefined($scope.additionals['selectedProductClass'])) {
                        $scope.additionals['selectedProductClass'] = [];
                }
                $scope.additionals['selectedProductClass'][keyTable] = [];

                if (angular.isUndefined($scope.additionals['controlMentionProduct'])) {
                        $scope.additionals['controlMentionProduct'] = [];
                }
                $scope.additionals['controlMentionProduct'][keyTable] = [];

                if (angular.isUndefined($scope.additionals['controlClientProduct'])) {
                        $scope.additionals['controlClientProduct'] = [];
                }
                $scope.additionals['controlClientProduct'][keyTable] = [];

                $scope.additionals['loyalty_point_accumulated'][keyTable] = 0;
                $scope.additionals['total_product'][keyTable] = 0;
                $scope.additionals['total_product_discount'][keyTable] = 0;
                $scope.additionals['total_client_discount'][keyTable] = 0;
                $scope.additionals['total_loyalty_point_discount'][keyTable] = 0;

                $scope.additionals['discount_campaigns'][keyTable] = [];
                $scope.modelDataOrder[keyTable] = {};

        }
        
        $scope.additionals['changeFieldPhone'] = function(model, keyTable) {
                Crud.get($scope.pathOrder + '/getClients?client_phone=' + model.order_phone)
                        .success(function(data) {
                                $scope.additionals['clients'] = data.clients;
                                if (model['order_phone'] != '') {
                                        if (!angular.isUndefined($scope.additionals['clients'][0])) {
                                                if (!angular.isUndefined($scope.additionals['clients'][0]['client_first_name'])) {
                                                        $scope.modelDataOrder[keyTable].client_first_name = $scope.additionals['clients'][0]['client_first_name'];
                                                }
                                                if (!angular.isUndefined($scope.additionals['clients'][0]['client_last_name'])) {
                                                        $scope.modelDataOrder[keyTable].client_last_name = $scope.additionals['clients'][0]['client_last_name'];
                                                }
                                                $scope.modelDataOrder[keyTable].client_id = $scope.additionals['clients'][0]['id'];
                                                $scope.modelDataOrder[keyTable].client_email = $scope.additionals['clients'][0]['client_email'];
                                                $scope.modelDataOrder[keyTable].client_gdpr = $scope.additionals['clients'][0]['client_gdpr'];
                                                if (model['client_gdpr'] == 0) {
                                                        $scope.modelDataOrder[keyTable].client_gdpr = false;
                                                }
                                                if (model['client_gdpr'] == 1) {
                                                        $scope.modelDataOrder[keyTable].client_gdpr = true;
                                                }
                                                model.client_cutlery = $scope.additionals['clients'][0]['client_cutlery'];
                                                if (model['client_cutlery'] == 0) {
                                                        $scope.modelDataOrder[keyTable].client_cutlery = false;
                                                }
                                                if (model['client_cutlery'] == 1) {
                                                        $scope.modelDataOrder[keyTable].client_cutlery = true;
                                                }

                                        } else {
                                                $scope.modelDataOrder[keyTable].client_first_name = '';
                                                $scope.modelDataOrder[keyTable].client_last_name = '';
                                                $scope.modelDataOrder[keyTable].client_email =  '';
                                        }
                                }

                                if ($scope.actionOrder[keyTable] == 'store') {
                                        if (!angular.isUndefined(data.clients[0])) {
                                                if (!angular.isUndefined(data.clients[0]['discount_campaigns'])) {
                                                        $scope.additionals['discount_campaigns'][keyTable] = data.clients[0]['discount_campaigns'];
                                                        $scope.additionals['applyDiscountCampaign'](keyTable);
                                                        $scope.additionals['changeSelectDiscountEvent']($scope.modelDataOrder[keyTable].discount_id, $scope.modelDataOrder[keyTable].order_amount, $scope.modelDataOrder[keyTable].order_shipping, keyTable);
                                                } else {
                                                        $scope.additionals['discount_campaigns'][keyTable] = [];
                                                }
                                        } else {
                                                $scope.additionals['discount_campaigns'][keyTable] = [];
                                        }

                                        if (!angular.isUndefined(data.clients[0])) {
                                                if (!angular.isUndefined(data.clients[0]['loyalty_point_accumulated'])) {
                                                        $scope.additionals['loyalty_point_accumulated'][keyTable] = data.clients[0]['loyalty_point_accumulated'];
                                                } else {
                                                        $scope.additionals['loyalty_point_accumulated'][keyTable] = 0;
                                                }
                                        } else {
                                                $scope.additionals['loyalty_point_accumulated'][keyTable] = 0;
                                        }

                                }
                                if ($scope.actionOrder[keyTable] == 'update') {

                                        if ($scope.order_phone_original == model['order_phone']) {
                                                $scope.additionals['discount_campaigns'][keyTable] = model['discount_campaigns'];
                                                $scope.additionals['applyDiscountCampaign'](keyTable);
                                                model['order_total'] = $scope.modelDataOrder[keyTable]['order_total'];
                                                $scope.additionals['changeSelectDiscountEvent']($scope.modelDataOrder[keyTable].discount_id, $scope.modelDataOrder[keyTable].order_amount, $scope.modelDataOrder[keyTable].order_shipping, keyTable);
                                                if (model['order_total'] == 0) {
                                                        model['order_total'] = $scope.additionals['total_product'][keyTable];
                                                }
                                        }

                                        if ($scope.order_phone_original != model['order_phone']) {

                                                if (!angular.isUndefined(data.clients[0])) {
                                                        if (!angular.isUndefined(data.clients[0]['loyalty_point_accumulated'])) {
                                                                $scope.additionals['loyalty_point_accumulated'][keyTable] = data.clients[0]['loyalty_point_accumulated'];
                                                        } else {
                                                                $scope.additionals['loyalty_point_accumulated'][keyTable] = 0;
                                                        }
                                                } else {
                                                        $scope.additionals['loyalty_point_accumulated'][keyTable] = 0;
                                                }
                                                $scope.modelDataOrder[keyTable]['loyalty_point_selected'] = 0;
                                                $scope.modelDataOrder[keyTable]['order_loyalty_point_discount'] = 0;
                                                $scope.additionals['total_loyalty_point_discount'][keyTable] = 0;
                                        }

                                }


                        });

        }

        /* cancel order */
        $scope.cancelOrder = function(ev, model, keyTable) {

              if (angular.isUndefined($scope.additionals['controlPayment'])) {
                        $scope.additionals['controlPayment'] = [];
                 }
                $scope.additionals['controlPayment'][keyTable] = false;
                
                 if (angular.isUndefined($scope.additionals['controlDiscountOrder'])) {
                        $scope.additionals['controlDiscountOrder'] = [];
                 }
                $scope.additionals['controlDiscountOrder'][keyTable] = false;

                $scope.errors = {};
                $scope.actionOrder[keyTable] = 'store';
                $scope.additionals['total_product'][keyTable] = 0;

                if (angular.isUndefined($scope.additionals['selectedCategory'])) {
                        $scope.additionals['selectedCategory'] = [];
                 }
                $scope.additionals['selectedCategory'][keyTable] = {};
                
               if (angular.isUndefined( $scope.additionals['selectedSeatsClass'])) {
                        $scope.additionals['selectedSeatsClass'] = [];
                }
                 $scope.additionals['selectedSeatsClass'][keyTable] = '';
                if (angular.isUndefined( $scope.additionals['selectedSeats'])) {
                        $scope.additionals['selectedSeats'] = [];
                }
                 $scope.additionals['selectedSeats'][keyTable] = '';
                if (angular.isUndefined( $scope.additionals['selectedSeatsModel'])) {
                        $scope.additionals['selectedSeatsModel'] = [];
                }
                $scope.additionals['selectedSeatsModel'][keyTable] = false;
                
                $scope.additionals['controlCategories'] = [];
                $scope.additionals['controlProducts'] = [];
                $scope.additionals['controlMentionProduct'] = [];
                $scope.additionals['controlClientProduct'] = [];

                if (angular.isUndefined($scope.additionals['supplements'])) {
                        $scope.additionals['supplements'] = [];
                }
                $scope.additionals['supplements'][keyTable] = [];

                if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                        $scope.additionals['selectedProduct'] = [];
                }
                $scope.additionals['selectedProduct'][keyTable] = {};

                if (angular.isUndefined($scope.additionals['selectedProduct'])) {
                        $scope.additionals['selectedProduct'] = [];
                }
                $scope.additionals['selectedProduct'][keyTable].food_product_quantity = 0;

                if (angular.isUndefined($scope.additionals['selectedProductClass'])) {
                        $scope.additionals['selectedProductClass'] = [];
                }
                $scope.additionals['selectedProductClass'][keyTable] = [];

                if (angular.isUndefined($scope.additionals['discount_campaigns'])) {
                        $scope.additionals['discount_campaigns'] = [];
                }
                $scope.additionals['discount_campaigns'][keyTable] = [];

                if (angular.isUndefined($scope.additionals['loyalty_point_accumulated'])) {
                        $scope.additionals['loyalty_point_accumulated'] = [];
                }
                $scope.additionals['loyalty_point_accumulated'][keyTable] = [];

                $scope.additionals['searchTermCategory'][keyTable] = '';
                $scope.additionals['searchTermProduct'][keyTable] = '';
                $scope.additionals['searchTermSupplement'][keyTable] = '';

                $scope.modelDataOrder[keyTable] = {};

                $scope.additionals['total_product'][keyTable] = 0;
                $scope.additionals['total_product_discount'][keyTable] = 0;
                $scope.additionals['total_client_discount'][keyTable] = 0;
                $scope.additionals['total_loyalty_point_discount'][keyTable] = 0;

                $scope.additionals['controlSupplements'][keyTable] = false;
                $scope.additionals['on'][keyTable] = true;

                if (angular.isUndefined($scope.additionals['food_products'])) {
                        $scope.additionals['food_products'] = [];
                }
                $scope.additionals['food_products'][keyTable] = [];
        };
       
        /* save order */
         if (angular.isUndefined($scope.additionals['controlShowOrderRestaurant'])) {
                $scope.additionals['controlShowOrderRestaurant'] = [];
          }
        $scope.addOrder = function($event, keyTable){ 
                if (angular.isUndefined($scope.additionals['controlShowOrderRestaurant'][keyTable])) {
                        $scope.additionals['controlShowOrderRestaurant'][keyTable] = 0;
                  }
                $scope.additionals['controlShowOrderRestaurant'][keyTable] = ! $scope.additionals['controlShowOrderRestaurant'][keyTable];
        }
        $scope.saveOrder = function(ev, idTable, keyTable) {
                
                $scope.actionOrder[keyTable] = 'store';
                if (!angular.isUndefined($scope.additionals['internFunctionOrder'])) {
                        $scope.additionals['internFunctionOrder'](ev, $scope.modelDataOrder[keyTable], keyTable);
                }
                $scope.isLoading = true;

                var post = $scope.modelDataOrder[keyTable];
                post['table_id'] = idTable;
                if($scope.tables == 0){
                       post['shipping_method_id'] = 2; 
                       post['edit_from_restaurant'] = 1; 
                }

                Crud.save($scope.additionals['content_type'], post, $scope.pathOrder)
                        .success(function(data) {
                                if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                } else {
                                        if (!angular.isUndefined($scope.additionals['functionResultOrder'])) {
                                                $scope.additionals['functionResultOrder'](ev, data, keyTable);
                                        }
                                        if (data.currentModel) {
                                                
                                                $scope.modelOrderLast[keyTable] = data.currentModel;
                                                var post = {};
                                                post['id'] = data.currentModel.id;
                                                post['route'] = 'printOrderAsincron';
                                                $scope.additionals['printOrderAsincron']($scope.pathOrder, post);
                                        }
                                }

                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.actionOrder[keyTable] = 'store';
                                $scope.additionals['total_product'][keyTable] = 0;
                                $scope.additionals['buttonDisabled'] = false;

                        })
                        .error(function(data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                if (!angular.isUndefined($scope.additionals['functionErrors'])) {
                                        $scope.additionals['functionErrors'](ev, data);
                                }
                                $scope.additionals['buttonDisabled'] = false;
                        });

        };

        /* make payments */
        $scope.makePaymentsOrder = function(ev,  pathOrder, modelId, keyTable) {
                ev.stopPropagation();
                if (angular.isUndefined($scope.additionals['controlShowOrderRestaurant'][keyTable])) {
                        $scope.additionals['controlShowOrderRestaurant'][keyTable] = 0;
                  }
                $scope.additionals['controlShowOrderRestaurant'][keyTable] = ! $scope.additionals['controlShowOrderRestaurant'][keyTable];
                
                $scope.actionOrder[keyTable] = 'payment';
                 if (angular.isUndefined($scope.additionals['controlPayment'])) {
                          $scope.additionals['controlPayment'] = [];
                 }
                $scope.additionals['controlPayment'][keyTable] = true;
                Crud.show(modelId,  pathOrder)
                        .success(function(data) {
                                
                                model = data;
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function(item, key) {
                                        currentModel[key] = item;
                                });
                                $scope.modelDataOrder[keyTable] = currentModel;
                                $scope.cancel = function() {
                                        $scope.modelDataOrder[keyTable] = {};
                                        $scope.errors = {};
                                        $scope.controlSH = false;
                                };
                
                                if (angular.isUndefined($scope.modelDataOrder[keyTable].payment_cash)) { 
                                        if (!angular.isUndefined($scope.modelDataOrder[keyTable]['order_total'])) { 
                                                $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable]['order_total']));
                                        } else {
                                                $scope.modelDataOrder[keyTable].payment_cash = 0;
                                        }
                                }
                                                       
                                if (!angular.isUndefined($scope.additionals['functionOrder'])) {
                                        $scope.additionals['functionOrder'](ev, $scope.modelDataOrder[keyTable], keyTable);
                                }
                                $scope.additionals['total_product_discount'][keyTable] = parseFloat(model.order_product_discount);
                                $scope.additionals['total_product'][keyTable] = parseFloat(model.order_amount) - parseFloat(model.order_product_discount);
                                $scope.additionals['total_client_discount'][keyTable] = parseFloat(model.order_client_discount);
                                $scope.additionals['total_loyalty_point_discount'][keyTable] = parseFloat(model.order_loyalty_point_discount);
                
                                if($scope.tables == 0){
                                        if (angular.isUndefined($scope.modelDataOrder[keyTable].payment_cash)) {
                                                if($scope.modelDataOrder[keyTable].payment_cash == 0 && $scope.modelDataOrder[keyTable].payment_card == 0 ){
                                                        $scope.modelDataOrder[keyTable].payment_cash =    $scope.modelDataOrder[keyTable]['order_total'];                     
                                                }
                                        }
                                }
                
                                $scope.makePayments = function() {
                                        $scope.additionals['buttonDisabled'] = true;
                                        if (!angular.isUndefined($scope.additionals['internFunctionOrder'])) {
                                                $scope.additionals['internFunctionOrder'](ev, $scope.modelDataOrder[keyTable], keyTable);
                                        }
                                        $scope.isLoading = true;
                
                                        var post = {};
                                        angular.extend(post, $scope.modelDataOrder[keyTable]);
                                        if (post.order_status == 0) {
                                                post.order_status = 1;
                                        }
                                       delete post['food_products'];
                                       delete post['address'];
                                       post['route'] = 'makePayments';
                                       if($scope.tables == 0){
                                               post['shipping_method_id'] = 2; 
                                               post['edit_from_restaurant'] = 1; 
                                        }
                                        
                                        Crud.post('form-urlencoded', post, $scope.path + '/makePayments')
                                      
                                                .success(function(data) {
                                                        if (!angular.isUndefined(data.invalid)) {
                                                                $scope.additionals['invalid'] = data.invalid;
                                                        } else {
                                                                if (!angular.isUndefined($scope.additionals['functionResultOrder'])) {
                                                                        $scope.additionals['functionResultOrder'](ev, data, keyTable);
                                                                }
                                                        }
                                                        $scope.errors = {};
                                                        $scope.isLoading = false;
                                                        $scope.actionOrder[keyTable] = 'store';
                                                        $scope.additionals['buttonDisabled'] = false;
                                                        $scope.modelDataOrder[keyTable] = {};
                                                })
                                                .error(function(data) {
                                                        $scope.actionOrder[keyTable] = 'update';
                                                        $scope.isLoading = false;
                                                        $scope.errors = data.errors;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                });
                                };


                     });
        }
                        
        /* edit order */
        $scope.editOrder = function(ev, path, modelId, keyTable) {
                ev.stopPropagation();
                if (angular.isUndefined($scope.additionals['controlPayment'])) {
                        $scope.additionals['controlPayment'] = [];
                 }
                $scope.additionals['controlPayment'][keyTable] = false;
                
                 if (angular.isUndefined($scope.additionals['controlDiscountOrder'])) {
                        $scope.additionals['controlDiscountOrder'] = [];
                 }
                $scope.additionals['controlDiscountOrder'][keyTable] = false;
                
                $scope.actionOrder[keyTable] = 'update';
                Crud.show(modelId, path)
                        .success(function(data) {

                                if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                                        $scope.additionals['dispatchTime'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                                }
                                if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                        $scope.additionals['kitchenTime'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                                }
                                if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                                        $scope.additionals['distributionTime'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                                }
                                if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                                        $scope.additionals['deliveryTime'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                                }

                                $scope.additionals['discount_campaigns'][keyTable] = data['discount_campaigns'];

                                $scope.editModelOrder(ev, path, data, keyTable);

                                $scope.additionals['total_product_discount'][keyTable] = parseFloat(data.order_product_discount);
                                $scope.additionals['total_product'][keyTable] = parseFloat(data.order_amount) - parseFloat(data.order_product_discount);
                                $scope.additionals['total_client_discount'][keyTable] = parseFloat(data.order_client_discount);
                                $scope.additionals['total_loyalty_point_discount'][keyTable] = parseFloat(data.order_loyalty_point_discount);

                        });
        }

        $scope.editModelOrder = function(ev, path, model, keyTable) {

                if (angular.isUndefined($scope.additionals['controlShowOrderRestaurant'][keyTable])) {
                        $scope.additionals['controlShowOrderRestaurant'][keyTable] = 0;
                  }
                $scope.additionals['controlShowOrderRestaurant'][keyTable] = ! $scope.additionals['controlShowOrderRestaurant'][keyTable];
                
                $scope.actionOrder[keyTable] = 'update';
                $scope.additionals['invalid'] = '';
                $scope.additionals['generateSeats'](Object.keys(model.clients).length+1, keyTable);
                
                var currentModel = {};
                angular.forEach(model, function(item, key) {
                        currentModel[key] = item;
                });
                $scope.modelDataOrder[keyTable] = currentModel;
                $scope.cancel = function() {
                        $scope.modelDataOrder[keyTable] = {};
                        $scope.errors = {};
                        $scope.controlSH = false;
                };
                
                if (angular.isUndefined($scope.modelDataOrder[keyTable].payment_cash)) { 
                        if (!angular.isUndefined($scope.modelDataOrder[keyTable]['order_total'])) { 
                                $scope.modelDataOrder[keyTable].payment_cash = $scope.formatDecimal(parseFloat($scope.modelDataOrder[keyTable]['order_total']));
                        } else {
                                $scope.modelDataOrder[keyTable].payment_cash = 0;
                        }
                }

                if (!angular.isUndefined($scope.additionals['functionOrder'])) {
                        $scope.additionals['functionOrder'](ev, $scope.modelDataOrder[keyTable], keyTable);
                }
                $scope.additionals['total_product_discount'][keyTable] = parseFloat(model.order_product_discount);
                $scope.additionals['total_product'][keyTable] = parseFloat(model.order_amount) - parseFloat(model.order_product_discount);
                $scope.additionals['total_client_discount'][keyTable] = parseFloat(model.order_client_discount);
                $scope.additionals['total_loyalty_point_discount'][keyTable] = parseFloat(model.order_loyalty_point_discount);
                               
               if($scope.tables == 0){
                         if (angular.isUndefined($scope.modelDataOrder[keyTable].payment_cash)) {
                                if($scope.modelDataOrder[keyTable].payment_cash == 0 && $scope.modelDataOrder[keyTable].payment_card == 0 ){
                                        $scope.modelDataOrder[keyTable].payment_cash =    $scope.modelDataOrder[keyTable]['order_total'];                     
                                }
                        }
                }
                                
                $scope.updateOrder = function() {
                        $scope.additionals['buttonDisabled'] = true;
                        if (!angular.isUndefined($scope.additionals['internFunctionOrder'])) {
                                $scope.additionals['internFunctionOrder'](ev, $scope.modelDataOrder[keyTable], keyTable);
                        }
                        $scope.isLoading = true;

                        var post = {};
                        angular.extend(post, $scope.modelDataOrder[keyTable]);
                        if (post.order_status == 0) {
                                post.order_status = 1;
                        }
                        if($scope.tables == 0){
                               post['shipping_method_id'] = 2; 
                               post['edit_from_restaurant'] = 1; 
                        }

                        Crud.update($scope.additionals['content_type'], post, $rootScope.typeId, path)
                                .success(function(data) {
                                        if (!angular.isUndefined(data.invalid)) {
                                                $scope.additionals['invalid'] = data.invalid;
                                        } else {
                                                if (!angular.isUndefined($scope.additionals['functionResultOrder'])) {
                                                        $scope.additionals['functionResultOrder'](ev, data, keyTable);
                                                }
                                                if (data.currentModel) {
                                                        var post = {};
                                                        post['id'] = data.currentModel.id;
                                                        post['route'] = 'printOrderAsincron';
                                                        $scope.additionals['printOrderAsincron'](path, post);
                                                }
                                        }
                                        $scope.errors = {};
                                        $scope.isLoading = false;
                                        $scope.actionOrder[keyTable] = 'store';
                                        $scope.additionals['buttonDisabled'] = false;
                                        $scope.modelDataOrder[keyTable] = {};
                                })
                                .error(function(data) {
                                        $scope.actionOrder[keyTable] = 'update';
                                        $scope.isLoading = false;
                                        $scope.errors = data.errors;
                                        $scope.additionals['buttonDisabled'] = false;
                                });
                };


        };

        /* print order */
        $scope.additionals['printOrderAsincron'] = function(path, post) {
                Crud.post('form-urlencoded', post, path + '/printOrderAsincron')
                        .success(function(dataPrint) {
                                if (!angular.isUndefined(dataPrint.errors_print)) {
                                        if (dataPrint.errors_print != '') {

                                                $mdDialog.show({
                                                        controller: DialogController,
                                                        templateUrl: 'printOrderAsincronDialog.tmpl.html',
                                                        parent: angular.element(document.body),
                                                        //targetEvent: ev,
                                                        clickOutsideToClose: true,
                                                        locals: {
                                                                pathTemplate: $scope.pathTemplate,
                                                                error: dataPrint,
                                                                additionals: $scope.additionals
                                                        }
                                                }).then();
                                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

                                                function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                                                        $scope.pathTemplate = pathTemplate;
                                                        $scope.cancel = function() {
                                                                $mdDialog.cancel();
                                                        };
                                                        $scope.additionals = additionals;
                                                        $scope.additionals['buttonDisabled'] = false;

                                                        $scope.errors_print = dataPrint.errors_print;
                                                        $scope.errors = error;
                                                }
                                        }
                                }
                        })
                        .error(function(dataPrint) {

                        });
        }

        $scope.printOrder = function(ev, path, model, doc, keyPayment) {

                if ((keyPayment != 'rest' && !angular.isUndefined(model.payments[keyPayment].payment_check) && model.payments[keyPayment].payment_check == true) || (keyPayment == 'rest' && !angular.isUndefined(model.payment_check_rest) && model.payment_check_rest == true)) {

                        $scope.additionals['buttonDisabled'] = true;
                        var post = {};
                        post['id'] = model.id;
                        post['route'] = 'printOrder';
                        post['doc'] = doc;
                        post['payments'] = model.payments;
                        if (model.payment_check_rest == true) {
                                post['payment_cash'] = model.payment_cash;
                                post['payment_card'] = model.payment_card;
                                post['payment_check_rest'] = model.payment_check_rest;
                        }
                        if (keyPayment != 'rest' && !angular.isUndefined(model.payments[keyPayment].payment_check) && model.payments[keyPayment].payment_check == true) {
                                post['payment_seat'] = model.payments[keyPayment].payment_seat;
                        }
                        if (keyPayment == 'rest' && !angular.isUndefined(model.payment_check_rest) && model.payment_check_rest == true) {
                                post['excluded_payment_seats'] = [];
                                var no = 0;
                                angular.forEach(model.payments, function(items, keys) {
                                        if (items['payment_seat'] != '' && items['payment_check'] == true) {
                                                post['excluded_payment_seats'][no] = items['payment_seat'];
                                                no++;
                                        }
                                });
                        }

                        Crud.post('form-urlencoded', post, path + '/printOrder')
                                .success(function(data) {
                                        $scope.additionals['buttonDisabled'] = false;
                                })
                                .error(function(data) {

                                        $mdDialog.show({
                                                controller: DialogController,
                                                templateUrl: 'printOrderDialog.tmpl.html',
                                                parent: angular.element(document.body),
                                                targetEvent: ev,
                                                clickOutsideToClose: true,
                                                locals: { pathTemplate: $scope.pathTemplate, error: data, additionals: $scope.additionals }
                                        }).then(function(destroyModel) {
                                        });
                                        DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'error', 'additionals'];

                                        function DialogController($scope, $mdDialog, pathTemplate, error, additionals) {
                                                $scope.pathTemplate = pathTemplate;
                                                $scope.cancel = function() {
                                                        $mdDialog.cancel();
                                                };
                                                $scope.additionals = additionals;
                                                $scope.additionals['buttonDisabled'] = false;

                                                $scope.errors = error.errors;
                                        }
                                });
                } else {
                        $scope.payment_check = 'Trebuie sa selectati mai intai clientul.';
                }

        }

        /* show order */
        
         $scope.showModelOrderDialog = function (ev, path, model, key, keyTable){

            ev.stopPropagation();
            $scope.additionals['invalid'] = '';
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'showOrderDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {pathTemplate: $scope.pathTemplate, additionals: $scope.additionals, currency: $rootScope.currency, themeShow:$rootScope.theme}
            }).then();

            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'currency', 'themeShow'];

            function DialogController($scope, $mdDialog, pathTemplate, additionals, currency, themeShow) {
                $scope.pathTemplate = pathTemplate;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.additionals = additionals;
                $scope.currency = currency;
                $scope.themeShow =  themeShow;
                                          
                Crud.show(model, path)
                            .success(function (data) { 
                                        $scope.keyTable = keyTable;
                                       if (angular.isUndefined($scope.modelDataShowOrder)) {
                                                $scope.modelDataShowOrder = [];
                                        }
                                        $scope.modelDataShowOrder[keyTable] = data;
                                        if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                                                        $scope.additionals['dispatchTime'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                                        }
                                        if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                                        $scope.additionals['kitchenTime'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                                        }
                                        if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                                                        $scope.additionals['distributionTime'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                                        }
                                        if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                                                        $scope.additionals['deliveryTime'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                                        }
                                        
                                        
                              /*  $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;*/

                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                      // }
                };
        }                    
        
        $scope.showModelOrder = function(ev, path, model, key, keyTable) {
                if ($scope.controlShowOrder[keyTable] == 0) {
                        $scope.controlShowOrder[keyTable] = 1;
                }
                if ($scope.controlShowOrder[keyTable] == 1) {

                        $scope.actionOrderSec[keyTable] = 'show';
                        Crud.show(model, path)
                                .success(function(data) {
                                        if (angular.isUndefined($scope.modelDataShowOrder)) {
                                                $scope.modelDataShowOrder = [];
                                        }
                                        $scope.modelDataShowOrder[keyTable] = data;
                                        if (!angular.isUndefined(data['order_start']) && !angular.isUndefined(data['validated_at'])) {
                                                $scope.additionals['dispatchTime'] = $scope.additionals['diffDatesMinutes'](data['order_start'], data['validated_at']);
                                        }
                                        if (!angular.isUndefined(data['processed_at']) && !angular.isUndefined(data['validated_at'])) {
                                                $scope.additionals['kitchenTime'] = $scope.additionals['diffDatesMinutes'](data['validated_at'], data['processed_at']);
                                        }
                                        if (!angular.isUndefined(data['delivered_at']) && !angular.isUndefined(data['processed_at'])) {
                                                $scope.additionals['distributionTime'] = $scope.additionals['diffDatesMinutes'](data['processed_at'], data['delivered_at']);
                                        }
                                        if (!angular.isUndefined(data['order_end']) && !angular.isUndefined(data['delivered_at'])) {
                                                $scope.additionals['deliveryTime'] = $scope.additionals['diffDatesMinutes'](data['delivered_at'], data['order_end']);
                                        }
                                        $scope.additionals['buttonDisabled'] = false;
                                });

                } else {
                        $scope.controlShowOrder[keyTable] = 0;
                }
        };

       /* change status order */
        $scope.changeStatusModelOrderDialog = function (ev, path, model, keyTable) {
            if( (model['order_status'] >= 3 && $scope.tables == 0) || (model['order_status'] == 3 && $scope.tables ==1) ){
                 $scope.additionals['invalid'] = '';
                                                  
                            $mdDialog.show({
                                controller: DialogController,
                                templateUrl: 'changeStatusOrderDialog.tmpl.html',
                                parent: angular.element(document.body),
                                targetEvent: ev,
                                clickOutsideToClose: true,
                                tables: $scope.tables,
                                model: model,
                                modelDataChangeStatusOrder: $scope.modelDataChangeStatusOrder,
                                locals: {pathTemplate: $scope.pathTemplate, additionals: $scope.additionals}
                            }).then();
                
                            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'model', 'modelDataChangeStatusOrder', 'tables'];

                            function DialogController($scope, $mdDialog, pathTemplate, additionals, model, modelDataChangeStatusOrder, tables) {
                                $scope.pathTemplate = pathTemplate;
                                $scope.cancel = function () {
                                    $mdDialog.cancel();
                                };
                                $scope.additionals = additionals;
                                $scope.keyTable = keyTable;
                
                                /* change status order */
                                if (angular.isUndefined($scope.modelDataChangeStatusOrder)) {
                                        $scope.modelDataChangeStatusOrder = {};
                                }
                               $scope.modelDataChangeStatusOrder.order_no = model.order_no;
                               $scope.modelDataChangeStatusOrder.order_status = model.order_status;
                               $scope.modelDataChangeStatusOrder.reason_nondelivery = model.reason_nondelivery;
                                            
                                $scope.changeStatusOrder = function () {
                                    $scope.additionals['buttonDisabled'] = true;
                                    $scope.isLoading = true;
                                    var post = {};
                                    post['route'] = 'changeStatusOrder';
                                    post['id'] = model.id;
                                    if(tables == 0) {
                                            post['order_status'] = $scope.modelDataChangeStatusOrder.order_status;
                                            post['reason_nondelivery'] = $scope.modelDataChangeStatusOrder.reason_nondelivery;
                                    }
                                    if(tables == 1) {
                                            post['order_status'] = 5;
                                            post['reason_nondelivery'] = '';
                                     }
                                     
                                    Crud.post('form-urlencoded', post, path + '/changeStatusOrder')
                                            .success(function (data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                    $scope.additionals['invalid'] = data.invalid;
                                                } 
                                                $scope.modelDataChangeStatusOrder[keyTable] = {};
                                                $scope.isLoading = false;
                                                $mdDialog.hide();
                                                $scope.additionals['buttonDisabled'] = false;
                                                 if(tables == 1) {
                                                        //$window.close();
                                                 }
                                                
                                            })
                                            .error(function (data) {
                                                $scope.errors = data.errors;
                                                $scope.isLoading = false;
                                                $scope.additionals['buttonDisabled'] = false;
                                            });
                                };
                            }
            
            }
        }                    
        
        /* cancellation order */
        $scope.cancellationModelOrderDialog = function (ev, path, model, keyTable) {
           ev.stopPropagation();
            $scope.additionals['invalid'] = '';
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'cancelOrderDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                model: model,
                locals: {pathTemplate: $scope.pathTemplate, additionals: $scope.additionals}
            }).then(function (cancellationOrder) {
            });

            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'model'];

            function DialogController($scope, $mdDialog, pathTemplate, additionals, model) {
                $scope.pathTemplate = pathTemplate;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.additionals = additionals;
                $scope.keyTable = keyTable;

                /* cancel order */
                if (angular.isUndefined($scope.modelDataCancellationOrder)) {
                        $scope.modelDataCancellationOrder = {};
                }
                $scope.modelDataCancellationOrder.order_no = model.order_no;
                $scope.modelDataCancellationOrder.reason_cancellation = model.reason_cancellation;
                
                $scope.cancellationOrder = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    var post = {};
                    post['route'] = 'cancellation';
                    post['id'] = model.id;
                    post['reason_cancellation'] = $scope.modelDataCancellationOrder.reason_cancellation;

                    Crud.post('form-urlencoded', post, path + '/cancellation')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    model['order_status'] = 2;
                                }
                                $scope.modelDataCancellationOrder[keyTable] = {};
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;

                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                };
            }
        }                    

        $scope.cancellationModelOrder = function(ev, path, model, keyTable) {
                if ($scope.controlShowOrder[keyTable] == 0) {
                        $scope.controlShowOrder[keyTable] = 1;
                }
                if ($scope.controlShowOrder[keyTable] == 1) {
                        $scope.actionOrderSec[keyTable] = 'cancellation';
                        if (!angular.isUndefined($scope.modelDataShowOrder)) {
                                if (!angular.isUndefined($scope.modelDataShowOrder[keyTable])) {
                                        $scope.modelDataShowOrder[keyTable] = {};
                                }
                        }

                        if (angular.isUndefined($scope.modelDataCancellationOrder)) {
                                $scope.modelDataCancellationOrder = [];
                        }
                        if (angular.isUndefined($scope.modelDataCancellationOrder[keyTable])) {
                                $scope.modelDataCancellationOrder[keyTable] = {};
                        }
                        $scope.modelDataCancellationOrder[keyTable].reason_cancellation = model.reason_cancellation;
                        $scope.modelDataCancellationOrder[keyTable].order_no = model.order_no;
                        $scope.cancellationOrder = function() {
                                $scope.additionals['buttonDisabled'] = true;
                                $scope.isLoading = true;
                                var post = {};
                                post['route'] = 'cancellation';
                                post['id'] = model.id;
                                post['reason_cancellation'] = $scope.modelDataCancellationOrder[keyTable].reason_cancellation;

                                Crud.post('form-urlencoded', post, path + '/cancellation')
                                        .success(function(data) {
                                                if (!angular.isUndefined(data.invalid)) {
                                                        $scope.additionals['invalid'] = data.invalid;
                                                } else {
                                                        model['order_status'] = 2;
                                                }
                                                $scope.modelDataCancellationOrder[keyTable] = {};
                                                $scope.isLoading = false;
                                                $scope.additionals['buttonDisabled'] = false;
                                                $scope.cancelShowOrder(keyTable);

                                        })
                                        .error(function(data) {
                                                $scope.errors = data.errors;
                                                $scope.isLoading = false;
                                                $scope.additionals['buttonDisabled'] = false;
                                        });
                        };
                }
        };

        /* transfer client */
        $scope.additionals['transfer'] = function (ev, pathOrder, keyTable) {
                
                var model = $scope.modelDataOrder;
                console.log($scope.additionals['selectedSeatsModel'][keyTable])
                console.log($scope.additionals['rangeSeats'][keyTable])
                
                 var groups = $scope.additionals['groupArrayByProp']($scope.modelDataOrder[keyTable]['food_products'], 'food_product_client_seat');
                                var noGroup = 0;
                console.log(groups)
                var modelTo = {}; modelTo['food_products'] = [];
                modelTo['key_from'] = keyTable;

                 angular.forEach($scope.additionals['selectedSeatsModel'][keyTable], function(item, key) {
                        if(item == true){
                                
                                console.log($scope.additionals['rangeSeats'][keyTable][key])
                             modelTo['food_products'] = groups[$scope.additionals['rangeSeats'][keyTable][key]];
                        }
                                                
                });
                               
           ev.stopPropagation();
            $scope.additionals['invalid'] = '';
            $mdDialog.show({
                controller: DialogController,
                templateUrl: 'transferDialog.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                model: model,
                modelTo: modelTo,
                locals: {pathTemplate: $scope.pathTemplate, additionals: $scope.additionals}
            }).then(function (cancellationOrder) {
            });

            DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'additionals', 'model', 'modelTo'];

            function DialogController($scope, $mdDialog, pathTemplate, additionals, model, modelTo) {
                $scope.pathTemplate = pathTemplate;
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
                $scope.additionals = additionals;
               
                /* cancel order */
                if (angular.isUndefined($scope.modelDataTransferOrder)) {
                        $scope.modelDataTransferOrder = {};
                }
                                
               // $scope.modelDataTransferOrder.table_id = model.order_no;
                //$scope.modelDataTransferOrder.reason_cancellation = model.reason_cancellation;
                
                $scope.transferClient = function () {
                        
                        console.log( $scope.modelDataTransferOrder)
                       console.log(model)
                       console.log(modelTo)
                       
                        var key_to = $scope.additionals['restaurant']['tables'].map(function(e) {
                                        return e['id'];
                                }).indexOf(parseInt($scope.modelDataTransferOrder.id_to));
                                
                                console.log(key_to)
                                if (key_to >=  0) {  
                                       
                                       if (angular.isUndefined(model[key_to])) {
                                                model[key_to] = {};
                                       }
                                                
                                         model[key_to]['food_products'] = modelTo['food_products'];
                                        console.log(model)
                                }
                                        
                        
                  //  $scope.additionals['buttonDisabled'] = true;
                 //   $scope.isLoading = true;
                    var post = {};
                    post['route'] = 'transfer';
                    post['id'] = model.id;
                    //post['reason_cancellation'] = $scope.modelDataTransferOrder.reason_cancellation;

                   /* Crud.post('form-urlencoded', post, pathOrder + '/transfer')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    model['order_status'] = 2;
                                }
                                $scope.modelDataTransferOrder[keyTable] = {};
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;

                            })
                            .error(function (data) {
                                $scope.errors = data.errors;
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
                            });*/
                };
            }
        }                    


        $scope.additionals['closeTimeSearchOrder'] = function(ev, field, keyTable) {
                if (ev.keyCode == 46) {
                        if (field == 'timeTo') {
                                $scope.searchOrder[keyTable].timeTo = undefined;
                        }
                        if (field == 'timeFrom') {
                                $scope.searchOrder[keyTable].timeFrom = undefined;
                        }
                }
        }

        /* get orders */
        if (angular.isUndefined($scope.modelOrderLast)) {
                $scope.modelOrderLast = [];
        }  
         $scope.getLastOrderTable = function(pathOrder, keyTable) {
                
                /*if (angular.isUndefined($scope.modelOrderLast[keyTable])) {
                         $scope.modelOrderLast[keyTable] = {};
                } */      
                 var pathOrderReq = pathOrder + '/getLastOrderTable';
                 pathOrderReq = pathOrderReq + '?tableId=' + $scope.idTable;
                 var crud = Crud.get(pathOrderReq);
                        
                      crud.success(function(data) {
                                if (!angular.isUndefined(data.invalid)) {
                                        $scope.additionals['invalid'] = data.invalid;
                                } else {
                                        if (!angular.isUndefined(data)) {
                                                  $scope.modelOrderLast[keyTable] = data;
                                         }
                                    }                                    
                            });
          }
          
        $scope.getOrders = function(pathOrder, offset, per_page) {

                if (angular.isUndefined(per_page) || per_page == 'undefined') {
                        per_page = perPageOrder;
                }
                $scope.additionals['buttonDisabledPagination'] = true;
                $scope.rangeOrder = [];
                if (angular.isUndefined($scope.no_pagesOrder)) {
                        $scope.no_pagesOrder = 1;
                }
                $scope.isLoadingPaginationOrder = true;
                $scope.$watch('no_pagesOrder', function(item) {
                        item = $scope.no_pagesOrder;
                }, true);

                var keyTable = $scope.selectedIndex;
                if ($scope.controlSearchOrder[keyTable] == 1) {
                        $scope.searchOrder[keyTable]['route'] = 'search';
                        if($scope.tables == 1){
                                $scope.searchOrder[keyTable]['tableId'] = $scope.idTable;
                        }
                        if($scope.tables == 0){
                                $scope.searchOrder[keyTable]['shippingId'] = 2;
                        }
                        var pathOrderReq = pathOrder + '/search?page=' + offset + '&per_page=' + per_page;
                        var crud = Crud.post('form-urlencoded', $scope.searchOrder[keyTable], pathOrderReq);
                } else {
                        var pathOrderReq = pathOrder + '/index?page=' + offset + '&per_page=' + per_page;
                        if($scope.tables == 1){
                                pathOrderReq = pathOrderReq + '&tableId=' + $scope.idTable;
                        }
                        if($scope.tables == 0){
                                pathOrderReq = pathOrderReq + '&shippingId=2';
                        }
                        var crud = Crud.get(pathOrderReq);
                }
                crud.success(function(data) {
                        if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                        } else {
                                if (!angular.isUndefined(data.data)) {
                                        if (data.data.length > 0) {
                                                
                                                $scope.stop = data.next_page_url;
                                                $scope.fromOrder = data.from;
                                                $scope.toOrder = data.to;
                                                $scope.totalOrder = data.total;
                                                $scope.no_pagesOrder = Math.ceil(data.total / data.per_page);

                                                if (per_page == 0) {
                                                        $scope.rangeOrder = [{}];
                                                } else {
                                                        for (var i = 0; i < $scope.no_pagesOrder; i++) {
                                                                $scope.rangeOrder[i] = i;
                                                        }
                                                }
                                                $scope.modelsOrder = data.data;
                                                $scope.modelsOrder.per_page = data.per_page;
                                                $scope.modelsOrder.current_page = data.current_page;

                                        } else {
                                                $scope.modelsOrder = [];
                                        }
                                        $scope.orders_by_day = data.orders_by_day;
                                        //$scope.total['order'] = data.total;
                                } else {
                                        $scope.orders_by_day = data.orders_by_day;
                                        $scope.modelsOrder = data.data;
                                        //$scope.total['order'] = data.total;
                                }

                        }
                        $scope.isLoadingPaginationOrder = false;
                        $scope.additionals['buttonDisabledPagination'] = false;

                });

        };

        /* mqtt */
        Mqtt.addListener({ 'id': 'orderUpdated', 'funct': updatedOrder });
        function updatedOrder(result, channel) {
                //console.log(channel);
                //console.log(result);

                if (channel == 'order_updated') {
                        $scope.mqttUpdateOrder(result, result.current_status, result.ex_status);
                }

                if (channel == 'many_orders') {
                        $scope.mqttUpdateManyOrders(result);
                }
                
                 if (channel == 'restaurant_table_channel') { 
                        if (result.action == 'changeStatusTable') {
                                if (!angular.isUndefined($scope.additionals['restaurant'])) {
                                               
                                        if (!angular.isUndefined($scope.additionals['restaurant']['tables'])) {
                                                var positionTable = $scope.additionals['restaurant']['tables'].map(function(e) {
                                                                return e['id'];
                                                }).indexOf(parseInt(result['id']));
                                                if (positionTable >= 0) {
                                                        $scope.additionals['restaurant']['tables'][positionTable]['table_status'] = result.table_status;
                                                        $scope.additionals['restaurant']['tables'][positionTable]['table_start'] = result.table_start;
                                                        $scope.$apply();
                                                }
                                        }
                                }
                        }                       
                }
                

        }

        $scope.mqttUpdateOrder = function(model, current_status, ex_status) {
                /*console.log(current_status)
                 console.log(ex_status)*/

                if (ex_status == -1) {//case of store
                        if (!angular.isUndefined($scope.modelsOrder)) {
                                var positionUpdated = $scope.modelsOrder.map(function(e) {
                                        return e['id'];
                                }).indexOf(parseInt(model.id));
                                if (positionUpdated < 0) {  
                                
                                         if ($scope.controlSearchOrder != true && moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') 
                                                && ($scope.tables == 1 && model.shipping_method_id == 3 && model.table.table_id ==  $scope.idTable && parseInt(model.created_by_id) == parseInt($rootScope.session.user.id)) || ($scope.tables == 0 && model.shipping_method_id == 2 && (model.order_status >= 3 || parseInt(model.created_by_id) == parseInt($rootScope.session.user.id)     ))) {

                                                        if (angular.isUndefined($scope.fromOrder) || $scope.fromOrder == 'null' || $scope.fromOrder == null) {
                                                                $scope.fromOrder = 1;
                                                        }
                                                        var current_page = $scope.modelsOrder.current_page;
                                                        $scope.modelsOrder.unshift(model);
                                                        $scope.modelsOrder = $filter('orderBy')($scope.modelsOrder, 'order_start', true);

                                                        $scope.modelsOrder = $scope.modelsOrder.filter((li, idx, self) => self.map(itm => itm.id).indexOf(li.id) === idx);
                                                        $scope.modelsOrder.current_page = current_page;
                                                                                               
                                        }
                                } 
                        }
                } else {
                       
                        if (!angular.isUndefined($scope.modelsOrder)) {
                                var positionUpdated = $scope.modelsOrder.map(function(e) {
                                        return e['id'];
                                }).indexOf(parseInt(model.id));
                                if (positionUpdated >= 0) {
                                          if ($scope.controlSearchOrder != true && moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') 
                                                && ($scope.tables == 1 && model.shipping_method_id == 3 && model.table.table_id ==  $scope.idTable && parseInt(model.created_by_id) == parseInt($rootScope.session.user.id)) || ($scope.tables == 0 && model.shipping_method_id == 2 && (model.order_status >= 3 || parseInt(model.created_by_id) == parseInt($rootScope.session.user.id)     ))) {
                                                $scope.modelsOrder[positionUpdated] = model;
                                                /*if(model.shipping_method_id == 3 && model.order_status == 3){
                                                        $scope.addRestaurantNotification(model.order_no);
                                                }*/
                                               if($scope.tables == 1){
                                                         if($scope.modelOrderLast[$scope.selectedIndex].id == model.id){
                                                                $scope.modelOrderLast[$scope.selectedIndex] = model;                                                                
                                                        }
                                                }
                                        } else {
                                                $scope.modelsOrder.splice(positionUpdated, 1);
                                        }
                                } else {
                                        if ($scope.controlSearchOrder != true && moment().format('DD/MM/YYYY') == moment(model.order_start).format('DD/MM/YYYY') 
                                                && ($scope.tables == 1 && model.shipping_method_id == 3 && model.table.table_id ==  $scope.idTable && parseInt(model.created_by_id) == parseInt($rootScope.session.user.id)) || ($scope.tables == 0 && model.shipping_method_id == 2 && (model.order_status >= 3 || parseInt(model.created_by_id) == parseInt($rootScope.session.user.id)     ))) {   
                                                        if (angular.isUndefined($scope.fromOrder) || $scope.fromOrder == 'null' || $scope.fromOrder == null) {
                                                                $scope.fromOrder = 1;
                                                        }
                                                    var current_page = $scope.modelsOrder.current_page;
                                                        $scope.modelsOrder.unshift(model);
                                                        $scope.modelsOrder = $filter('orderBy')($scope.modelsOrder, 'order_start', true);

                                                        $scope.modelsOrder = $scope.modelsOrder.filter((li, idx, self) => self.map(itm => itm.id).indexOf(li.id) === idx);
                                                        $scope.modelsOrder.current_page = current_page;
                                               
                                                       /*if(model.shipping_method_id == 3 && model.order_status == 3){
                                                                $scope.addRestaurantNotification(model.order_no);
                                                        }*/
                                       }
                                                       
                                }
                        }
                      
                }
                
                if(model.shipping_method_id == 3 && model.order_status == 3){
                        $scope.addRestaurantNotification(model.order_no);
                }
                                                             
                $scope.$apply();
        };

        $scope.mqttUpdateManyOrders = function(models) {
                if (models[0].current_status == -1) { //case for delete orders
                        angular.forEach(models, function(items, keys) {
                                if (!angular.isUndefined($scope.modelsOrder)) {
                                        var positionUpdated = $scope.modelsOrder.map(function(e) {
                                                return e['id'];
                                        }).indexOf(parseInt(items.order_id));
                                        if (positionUpdated >= 0) {
                                                if (!angular.isUndefined($scope.total)) {
                                                        $scope.total['order'] = $scope.total['order'] - 1;
                                                        if ($scope.total['order'] < 0) {
                                                                $scope.total['order'] = 0;
                                                        }
                                                }
                                                $scope.modelsOrder.splice(positionUpdated, 1);
                                        }
                                }
                        });
                }

        }

        $scope.additionals['restaurants_notifications'] = [];
        $scope.addRestaurantNotification = function (value) {
               $scope.additionals['restaurants_notifications'].push(value);
        }
        $scope.closeRestaurantNotification = function (key, notification) {
                 $scope.additionals['restaurants_notifications'].splice(key, 1);
        }
        
           $scope.additionals['timerOrder'] = function(date) {
                        var start = date;
                        var end = moment();
                
                        var duration = moment.duration(end.diff(start));
                        return moment.utc(duration.as('milliseconds')).format('HH:mm:ss');
                }
                $rootScope.stopTimer = $interval(function() {
                        $scope.additionals['timerOrder']();
                        
                }, 1000);

}


        }]
);
